webpackJsonp([0],{

/***/ "+bH1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'strategy',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/estrategia/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  }
});

/***/ }),

/***/ "+jPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-footer'
});

/***/ }),

/***/ "+m3M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Dyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'peoples',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/pessoas/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
});

/***/ }),

/***/ "/PVP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "07is":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/progress.cd987a2.mp4";

/***/ }),

/***/ "0rPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-fullscreen-text"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":"/intro/formulario"}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Avançar\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-float"},[_c('span',[_vm._v("I")]),_vm._v(" "),_c('span',[_vm._v("N")]),_vm._v(" "),_c('span',[_vm._v("T")]),_vm._v(" "),_c('span',[_vm._v("R")]),_vm._v(" "),_c('span',[_vm._v("O")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("A Transformação Digital já atingiu todos os setores do mercado mas, apesar disso, são poucos os que realmente entendem o que ela significa para os negócios e qual a sua relevância para a sobrevivência empresarial.")]),_vm._v(" "),_c('p',[_vm._v("Dada sua enorme magnitude, é difícil entender o panorama digital como um todo, então vamos começar o teste de maturidade digital a partir das definições básicas.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1tTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeoplesForm_vue__ = __webpack_require__("HXKR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eaef570_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeoplesForm_vue__ = __webpack_require__("SVQt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeoplesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eaef570_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeoplesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "20xW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerExperienceForm_vue__ = __webpack_require__("XrWg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248e63db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerExperienceForm_vue__ = __webpack_require__("uDv3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerExperienceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248e63db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerExperienceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2P8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      totalSteps: 7
    };
  },

  computed: {
    current: function current() {
      return this.$store.state.barProgress;
    },
    width: function width() {
      var perc = this.current * 100 / this.totalSteps;
      return "width: " + perc + "%";
    }
  }
});

/***/ }),

/***/ "2ebs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2nCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"CULTURA E LIDERANÇA","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/teste","next":"/teste/agilidade-operacional"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3/iJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("998L");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intro-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'understanding',
      questions: [{ field: 'td_understanding', value: 0, title: 'Eu tenho pleno entendimento da transformação digital e sei que ela vai impactar minha carreira, meu trabalho e as empresas onde trabalharei.' }, { field: 'td_understanding_corp', value: 0, title: 'Minha empresa tem pleno entendimento da transformação digital e sabe que ela impacta e vai impactar ainda mais nosso modelo de negócios.' }, { field: 'td_readiness', value: 0, title: 'Minha empresa já está preparada ou está se preparando para as diversas mudanças que ocorrerão digitalmente nos próximos anos.' }, { field: 'td_investment', value: 0, title: 'Minha empresa está investindo o suficiente em estratégias digitais para se adequar às mudanças do mercado e se preparar para as próximas.' }]
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 1);
  }
});

/***/ }),

/***/ "49wM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4FHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vFooter_vue__ = __webpack_require__("+jPC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768cbc0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vFooter_vue__ = __webpack_require__("ECk9");
function injectStyle (ssrContext) {
  __webpack_require__("jb5/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-768cbc0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768cbc0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4aXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("bQkl");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tecnologia_digital_form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'tecnologia_digital',
      questions: this.$store.state.questions.tecnologia_digital
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
});

/***/ }),

/***/ "5XmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      resubmitting: false,
      error: false
    };
  },

  computed: {
    current: function current() {
      return this.$store.state.requestError;
    },
    sendError: function sendError() {
      return this.error;
    }
  },
  methods: {
    sendemail: function sendemail() {
      var data = {
        cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
        experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
        empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
        tecnologia_digital: this.$store.state.tecnologia_digital,
        agilidade_operacional: this.$store.state.agilidade_operacional,
        test_results: this.$store.state.test_results
      };

      var link = 'mailto:premium@transformacaodigital.com';
      link += '?subject=' + encodeURIComponent('RESULTADO TD SCORE');
      link += '&body=' + encodeURIComponent('ID: ' + this.$store.state.userid);
      link += encodeURIComponent('\nNome: ' + this.$store.state.username);
      link += encodeURIComponent('\nResultado: ' + btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
      window.location = link;

      this.$store.commit('REQUEST_ERROR', false);
    },
    resend: function resend() {
      var _this = this;

      if (this.resubmitting) return;
      this.resubmitting = true;

      if (this.$store.state.userid) {

        this.error = true;

        var data = {
          cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
          experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
          empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
          tecnologia_digital: this.$store.state.tecnologia_digital,
          agilidade_operacional: this.$store.state.agilidade_operacional,
          test_results: this.$store.state.test_results
        };

        try {
          this.$http.post('/api/user/' + this.$store.state.userid + '/' + this.$store.state.usercode, data).then(function (response) {
            if (response.body && response.body.success) {
              //this.$store.commit('REQUEST_ERROR', false);
              _this.error = true;
            } else {
              _this.error = true;
            }
          }, function (response) {
            _this.error = true;
          });
        } catch (e) {
          this.error = true;
        }
      } else {
        this.error = true;
      }
    }
  }
});

/***/ }),

/***/ "5huc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Question__ = __webpack_require__("d5Sz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_questionsVuex__ = __webpack_require__("EFEc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vButton__ = __webpack_require__("wCtQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'questions',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_questionsVuex__["a" /* default */]],
  components: { Question: __WEBPACK_IMPORTED_MODULE_0__Question__["a" /* default */], vButton: __WEBPACK_IMPORTED_MODULE_2__vButton__["a" /* default */] },
  props: {
    title: String,
    items: Array,
    keyForm: String,
    prev: String,
    next: String
  }
});

/***/ }),

/***/ "5ypP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestError_vue__ = __webpack_require__("5XmR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0376c160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestError_vue__ = __webpack_require__("Yib5");
function injectStyle (ssrContext) {
  __webpack_require__("d5wn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0376c160"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0376c160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "67o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'conclution',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/resultado',
      allData: this.$store.getters.data,
      userid: this.$store.state.userid,
      usercode: this.$store.state.usercode,
      submitted: this.$store.state.submitted
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('TEST_CALCULATE_OVERALL');

    if (this.userid) {

      var data = {
        cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
        experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
        empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
        tecnologia_digital: this.$store.state.tecnologia_digital,
        agilidade_operacional: this.$store.state.agilidade_operacional,
        test_results: this.$store.state.test_results,
        submitted: true
      };

      try {
        this.$http.post('/api/user/' + this.userid + '/' + this.usercode, data).then(function (response) {}, function (response) {
          _this.$store.commit('REQUEST_ERROR', true);
        });
      } catch (e) {
        this.$store.commit('REQUEST_ERROR', true);
      }
    } else {
      this.$store.commit('REQUEST_ERROR', true);
    }
  }
});

/***/ }),

/***/ "6RyT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intro',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/cultura-e-lideranca',
      username: this.$store.state.username
    };
  }
});

/***/ }),

/***/ "6WF7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Process_vue__ = __webpack_require__("K5i+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1191d3c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__ = __webpack_require__("a67d");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Process_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1191d3c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-fullscreen-text"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title-main"},[_c('h1',[_vm._v("\n        Olá, "+_vm._s(_vm.username)+"\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Neste teste vamos ajudar você a identificar o seu nível de maturidade digital.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        O Score será calculado com base em cinco dimensões principais: Cultura e Liderança, Agilidade Operacional, Tecnologia Digital, Experiência do Cliente e Empreendedorismo Digital.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Vamos lá!\n      ")])]),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":"/teste/cultura-e-lideranca"}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Inicie o diagnóstico\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-float"},[_c('span',[_vm._v("I")]),_vm._v(" "),_c('span',[_vm._v("N")]),_vm._v(" "),_c('span',[_vm._v("T")]),_vm._v(" "),_c('span',[_vm._v("R")]),_vm._v(" "),_c('span',[_vm._v("O")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7zPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobile_detect__ = __webpack_require__("UMwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__("R5/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min__ = __webpack_require__("fP26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg__ = __webpack_require__("MICb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png__ = __webpack_require__("cf9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var isMobile = false;

if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  isMobile = true;
};

/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'result',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */] },
  data: function data() {
    return {
      slidesNames: ['final', 'geral', 'categoria1', 'categoria2', 'compartilhe'],
      nextScreen: '/result',
      initResults: {
        td_score_understanding: 0,
        td_score_people: 0,
        td_score_process: 0,
        td_score_customer_experience: 0,
        td_score_strategy: 0,
        td_score_overall: 0
      },
      results: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$store.state.results),
      resultText: {
        overall: { text: '', title: '' },
        people: { text: '', title: '' },
        process: { text: '', title: '' },
        customer_experience: { text: '', title: '' },
        strategy: { text: '', title: '' }
      },
      dataResultText: {
        overall: [{ maxScore: 20, title: 'Ainda temos um longo caminho pela jornada do digital', text: '<p>Ainda temos um longo caminho pela Transformação Digital. Mas não desanime!</p><p>Ser digital exige dedicação de toda a equipe, da direção ao estagiário. Um esforço coletivo para superar processos antigos e enferrujados, criar cultura e mindset digital, compartilhar constantemente informações para que as equipes trabalhem juntas em prol das metas da empresa e desenvolver ou contratar talentos para guiar a Transformação da empresa."</p>' }, { maxScore: 40, title: 'Vemos transformações no horizonte...', text: '<p>A sua empresa entende o impacto da Transformação Digital no mercado, mas ainda precisa definir um plano de ação para se adaptar às mudanças.</p><p>Promover ferramentas digitais para a otimização dos processos, dar espaço para talentos digitais e, principalmente, estimular a cultura digital em sua empresa, podem ser os primeiros passos para se transformar.</p>' }, { maxScore: 60, title: 'Ser digital já se tornou uma meta tangível', text: '<p>O digital já faz parte da rotina da empresa, seja nos processos ou nas entregas. Acredite, você já está à frente de muita gente!</p><p>Porém, esse é só o começo. Busque formas de implementar o digital em todos os processos da empresa, independente do setor, e cuide para que todos os touchpoints entre empresa-consumidor estimulem experiências únicas e alinhadas às expectativas do cliente.</p><p>Lembre de habilitar seus colaboradores para se tornarem talentos digitais e continue construindo sua cultura digital junto com toda a equipe.</p>' }, { maxScore: 80, title: 'Sua jornada digital está quase completa', text: '<p>Sorria, a sua empresa é digital. Como a Transformação é uma jornada contínua, é importante que agora você habilite os talentos digitais para se tornarem líderes e promoverem inovações constantes - sem nunca esquecer de entender as expectativas dos consumidores para promover experiências novas e únicas.</p><p>Aproveite o cenário favorável para estimular ainda mais a cultura digital da empresa através do trabalho colaborativo e da exposição dos resultados digitais alcançados pela equipe até aqui.</p>' }, { maxScore: 100, title: 'O seu DNA é digital', text: '<p>Ser digital é ser mutável e estar sempre pronto para novas adaptações - exatamente o caminho que a sua empresa está seguindo no cenário atual!</p><p>Não descanse e continue buscando e habilitando líderes e talentos digitais, além de tecnologias, para continuar fortalecendo a cultura digital e exceder as expectativas de experiência do consumidor.</p><p>Em pouco tempo, sua empresa será líder digital do seu setor de atuação.</p>' }],
        people: [{ maxScore: 20, title: 'Antes de entender a Transformação, entenda as pessoas', text: '<p>Todas as disrupções que vêm acontecendo se dão por conta de líderes que entenderam isso e utilizam tecnologias para liberar todo o potencial humano de seus colaboradores e consumidores.</p><p>Muitas vezes, o primeiro passo para tudo isso acontecer é dado pelo líder da empresa, mas nada impede que outros funcionários façam isso. Tudo pode depender de você!</p>' }, { maxScore: 40, title: 'Entenda que a Transformação Digital é sobre pessoas, não tecnologia', text: '<p>Acredite, são os seus colaboradores que vão fazer a Transformação Digital da sua empresa acontecer, não apenas a tecnologia.</p><p>Construa e compartilhe com todos os colaboradores uma nova cultura digital e certifique-se de que as pessoas estão sendo habilitadas para os novos processos.</p>' }, { maxScore: 60, title: 'Cortinas abertas para os protagonistas do show', text: '<p>Sua empresa entende o papel de destaque das pessoas na Transformação Digital. Hora de desenvolver novas habilidades digitais em seus colaboradores para evoluir talentos que vão sustentar a cultura digital da empresa.</p>' }, { maxScore: 80, title: 'Somos todos digitais', text: '<p>As pessoas são protagonistas da Transformação Digital e a sua empresa já sabe disso. Agora é hora de transformar seus talentos digitais em líderes de setores para estimular a inovação contínua e o fortalecimento da cultura digital.</p>' }, { maxScore: 100, title: 'Todo o potencial humano foi liberado', text: '<p>Sua empresa entende a importância de pessoas liderando o mundo digital e estimula sua evolução na Transformação Digital.</p><p>Continue desenvolvendo um trabalho dedicado a evoluir as habilidades digitais e de liderança dos seus colaboradores para estar sempre pronto para as novas adaptações."</p>' }],
        process: [{ maxScore: 20, title: 'Cuidado com a extinção...', text: '<p>Sua empresa ainda mantém processos analógicos que estão enraízados em modelos de negócios tradicionais, enquanto empresas que estão passando pela sua Transformação Digital utilizam processos digitais realizados de forma colaborativa entre todos os setores.</p><p>Repense os processos buscando metodologias ágeis e alinhadas com o digital para começar sua transformação.</p>' }, { maxScore: 40, title: 'Run, Forrest, Run!', text: '<p>Sua empresa começou a agilizar seus processos, mas ainda tem um longo caminho para percorrer.</p><p>Busque tecnologias que vão automatizar processos repetitivos para que sua equipe possa focar sua inteligência no core-business.</p>' }, { maxScore: 60, title: 'Halfway there...', text: '<p>Tudo está caminhando mais rápido do que o normal dentro da sua empresa. Os colaboradores estão percorrendo o caminho da Transformação Digital através de ferramentas e processos mais ágeis.</p><p>Os próximos passos consistem em traçar metas a serem alcançadas através do digital e buscar metodologias que vão facilitar as adaptações que ainda estão por vir.</p>' }, { maxScore: 80, title: 'A todo vapor', text: '<p>Processos digitais já fazem parte de toda a empresa. Sua jornada pela Transformação Digital já está bem adiantada, e é justamente essa a hora de acelerar o passo para não perder o ritmo.</p><p>Estimule o trabalho colaborativo das equipes em busca das metas traçadas e potencialize os processos através de novas ferramentas digitais que atendam às mudanças constantes do mercado digital.</p>' }, { maxScore: 100, title: 'Atingimos a velocidade da luz', text: '<p>Os processos da sua empresa já estão adptados ao modelo digital de trabalho. As equipes buscam constante evolução e colaboram entre si para que a jornada da Transformação Digital seja contínua.</p><p>Agora, é necessário ficar atento às novas tecnologias e tendências de mercado para novas adaptações, além de implementar de forma muito ágil qualquer mudança que se veja necessária.</p>' }],
        customer_experience: [{ maxScore: 20, title: '"Experiência do Cliente" é o que deve estar escrito em todos os memorandos da sua empresa', text: '<p>Entender sua força no atual cenário digital é o caminho para se manter relevante e, mais do que isso, não afundar.</p><p>Comece entendendo melhor os hábitos e as expectativas dos consumidores para redesenhar a jornada de compra de forma que todo o contato feito com sua empresa ofereça exepriências únicas para quem está do outro lado.</p>' }, { maxScore: 40, title: 'Não é à toa que você tem dois ouvidos e apenas uma boca', text: '<p>Sua empresa já deu alguns passos em direção à uma jornada de compra baseada na experiência do consumidor.</p><p>Para impulsioná-la ainda mais, entenda os resultados alcançados até aqui através dos feedbakcs do público-alvo e busque melhorias para, pelo menos, cumprir as expectativas - e depois, sim, excedê-las.</p>' }, { maxScore: 60, title: 'Test and Learn', text: '<p>Jornada de compra focada na experiência do consumidor já é uma realidade em sua empresa. Essa é a hora de testar novos produtos, serviços ou abordagens utilizando o digital para entender onde se está pisando e quais os próximos passos a serem dados.</p><p>Não desanime. Em vez disso, utilize a tecnologia a seu favor e estimule seus consumidores através do meio digital.</p>' }, { maxScore: 80, title: 'Navegue novos mares', text: '<p>A experiência do consumidor é resultado da união entre metas e jornada de compra com este foco, e sua empresa parece entender isso.</p><p>A busca pela perfeitção continua através de um modelo de negócio adaptado aos consumidores da era digital e a constante melhoria dos produtos ou serviços oferecidos de acordo com as expectativas do cliente.</p>' }, { maxScore: 100, title: 'Os seus clientes têm sorte por sua empresa existir no mercado', text: '<p>Investir continuamente em experiências únicas vai te ajudar a subir os degraus que levam à liderança do seu setor de mercado, mas isso exige total entendimento do consumidor - sejam seus hábitos ou suas expectativas. Traduzir suas expectativas em entregas potencializadas pelo digital - e mesmo rever completamente seu modelo de negócio para se alinhar - é o caminho que vai te levar além."</p>' }],
        strategy: [{ maxScore: 20, title: 'Não seja o Napoleão da era digital', text: '<p>Definir uma estratégia para passar pela Transformação Digital é o que vai manter sua empresa de portas abertas. O digital é um dividor de águas e, que não se adapta, acaba ficnado para trás.</p><p>Comece a sua jornada criando uma estrutura que sustente processos digitais para, então, criar e percorrer metas para a Transformação da sua empresa.</p>' }, { maxScore: 40, title: 'Dividir é multiplicar', text: '<p>O primeiro passo foi dado, sua empresa está definindo uma estratégia para passar pela Transformação Digital. É importante lembrar de ter o digital em primeiro plano em todos os próximos passos.</p><p>Faça o possível para que todos da empresa conheçam a estratégia definida, abra as portas para que todos os colaboradores possam opiniar e otimizar a estratégia e colete dados que mensurem os resultados alcançados para entender se tudo está alinhada às metas da empresa.</p>' }, { maxScore: 60, title: 'Aposte no seu time', text: '<p>A estratégia digital da sua empresa já foi colocada em prática. Para acelerá-la, crie um time dedicado à Transformação e liderado por algum talento digital.</p><p>Não esqueça de sempre disponibilizar as informações para toda a empresa, de forma a estimular a colaboração de todos em prol das mudanças digitais.</p>' }, { maxScore: 80, title: 'Siga o plano', text: '<p>Sua empresa possui uma estratégia digital consistente. Este é o momento para buscar iniciativas digitais que auxiliem o alcance das metas da empresa para, finalmente, ter o digital como core-business de toda a operação.</p><p>Neste estágio onde o digital já é muito ativo dentro da empresa, a preocupação com a segurança dos dados deve ser máxima para que nenhuma informação caia em mãos externas.</p>' }, { maxScore: 100, title: 'Parabéns por dominar a arte da guerra digital', text: '<p>A estratégia digital da sua empresa está alinhada com as disrupções que vêm acontecendo diariamente através da Transformação Digital. Hora de dar deixar sua segurança ainda mais robusta e buscar novas e maiores metas para ir além dos concorrentes através do digital.</p>' }]
      },
      faceBook: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    window.$loadImages([__WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png___default.a]).then(function () {
      return next();
    });
  },
  mounted: function mounted() {
    var _this = this;

    /* eslint-disable */
    window.fbAsyncInit = function () {
      FB.init({
        appId: '398443737018854',
        xfbml: true,
        version: 'v2.12'
      });
      FB.AppEvents.logPageView();
      _this.faceBook = FB;
    };

    (function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);js.id = id;
      js.src = 'https://connect.facebook.net/pt_BR/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    /* eslint-enable */

    this.processResultText();
    var logo = document.getElementById('headerLogo');

    if (isMobile) {
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.results);
      for (var i = 0; i < keys.length; i += 1) {
        this.initResults[keys[i]] = this.results[keys[i]];
      }
    }

    isMobile && this.animateNumbers(["td_score_understanding", "td_score_people", "td_score_process", "td_score_customer_experience", "td_score_strategy", "td_score_overall"], false);

    !isMobile && __WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min___default.a.initialize('#fullpage', {
      anchors: this.slidesNames,
      navigation: false,
      scrollBar: true,
      afterLoad: function afterLoad(anchor) {
        switch (anchor) {
          case _this.slidesNames[0]:
            _this.animateNumbers(['td_score_overall']);
            break;
          case _this.slidesNames[1]:
            _this.animateNumbers(['td_score_people', 'td_score_process', 'td_score_customer_experience', 'td_score_strategy'], false);
            break;
          case _this.slidesNames[2]:
            _this.animateNumbers(['td_score_people', 'td_score_process']);
            break;
          case _this.slidesNames[3]:
            _this.animateNumbers(['td_score_customer_experience', 'td_score_strategy']);
            break;
        }
      },
      onLeave: function onLeave(index, nextIndex) {
        if (nextIndex === _this.slidesNames.length) {
          logo.style.animationName = 'fade-to-bottom';
        } else logo.style.animationName = 'fade-to-bottom-reverse';
      }
    });
  },

  computed: {
    mobile: function mobile() {
      return !!new __WEBPACK_IMPORTED_MODULE_4_mobile_detect___default.a(window.navigator.userAgent).phone();
    },
    shareLinkedinUrl: function shareLinkedinUrl() {
      var url = encodeURI('https://score.transformacaodigital.com/');
      var text = encodeURI('Meu resultado foi ' + this.initResults.td_score_overall + '% - "' + this.resultText.overall.title + '". Descubra o seu: ' + url);
      return 'https://www.linkedin.com/shareArticle?url=' + url + '&summary=' + text;
    },
    shareTwitterUrl: function shareTwitterUrl() {
      var text = encodeURI('Meu resultado foi ' + this.initResults.td_score_overall + '% - "' + this.resultText.overall.title + '". Descubra o seu:');
      var url = encodeURI('https://score.transformacaodigital.com/');
      var hashtags = encodeURI('TransformaçãoDigital,MaturidadeDigital,TDScore');
      return 'https://twitter.com/share?url=' + url + '&hashtags=' + hashtags + '&text=' + text;
    }
  },
  methods: {
    shareFaceBook: function shareFaceBook() {
      /* eslint-disable */
      console.log('-- faceBook');
      console.log(this.faceBook);
      console.log('-- FB');
      console.log(FB);
      FB.ui({
        method: 'share',
        href: 'http://tdscore.herokuapp.com/',
        hashtag: '#tdscore',
        quote: 'Teste quote'
      }, function (response) {
        console.log(response);
      });
      /* eslint-enable */
    },
    processResultText: function processResultText() {
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.dataResultText);
      for (var i = 0; i < keys.length; i += 1) {
        this.scoreText(keys[i]);
      }
    },
    scoreText: function scoreText(score) {
      var scoreField = this.results['td_score_' + score];
      for (var i = 0; i < 5; i += 1) {
        var dataText = this.dataResultText[score][i];
        if (scoreField <= dataText.maxScore) {
          this.resultText[score] = {
            text: dataText.text,
            title: dataText.title
          };
          break;
        }
      }
    },
    animateNumbers: function animateNumbers(fields) {
      var _this2 = this;

      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var optionFields = [];
      for (var i = 0; i < fields.length; i += 1) {
        if (reset) this.initResults[fields[i]] = 0;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(optionFields, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, fields[i], this.results[fields[i]]));
      }
      __WEBPACK_IMPORTED_MODULE_5_gsap__["a" /* TweenMax */].to(this.initResults, 1, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, optionFields, {
        onUpdate: function onUpdate() {
          for (var _i = 0; _i < fields.length; _i += 1) {
            _this2.initResults[fields[_i]] = Math.ceil(_this2.initResults[fields[_i]]);
          }
        }
      }));
    },
    widthPercentage: function widthPercentage(value) {
      return 'width:' + value + '%';
    }
  }
});

/***/ }),

/***/ "8FPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Question__ = __webpack_require__("v/eD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_questionsVuexTeste__ = __webpack_require__("e7Pp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vButton__ = __webpack_require__("wCtQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'questions',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_questionsVuexTeste__["a" /* default */]],
  components: { Question: __WEBPACK_IMPORTED_MODULE_0__Question__["a" /* default */], vButton: __WEBPACK_IMPORTED_MODULE_2__vButton__["a" /* default */] },
  props: {
    title: String,
    items: Array,
    keyForm: String,
    prev: String,
    next: String
  }
});

/***/ }),

/***/ "9+OR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("AGILIDADE OPERACIONAL")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("No contexto da transformação digital, a otimização dos processos é um pilar fundamental para dar mais agilidade para as empresas, trazer respostas às demandas dos clientes e proporcionar serviços mais eficientes. Pensar os processos de forma diferente tende a gerar resultados ainda não explorados nas empresas.")]),_vm._v(" "),_c('p',[_vm._v("Nesta etapa vamos refletir sobre a aplicação de ferramentas, metodologias ágeis, além de confrontar seu mindset em alguns cenários.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "998L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questions_vue__ = __webpack_require__("5huc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a4d4f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questions_vue__ = __webpack_require__("q4MH");
function injectStyle (ssrContext) {
  __webpack_require__("ih3R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a4d4f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a4d4f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9FJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"Processos","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/pessoas/formulario","next":"/cliente"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9dW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-zoom"}},[(_vm.src)?_c('div',{staticClass:"modal-media"},[_c('div',{staticClass:"modal-background",on:{"click":function($event){$event.preventDefault();_vm.$emit('close')}}}),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"modal-close",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('close')}}},[_vm._v("X")]),_vm._v(" "),_c('video',{staticClass:"modal-video",attrs:{"autoplay":"","loop":"","width":"100%","src":_vm.src}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AQpC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AYiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("EMPREENDEDORISMO DIGITAL")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("Empreendedorismo é a disposição ou capacidade de idealizar, coordenar e realizar projetos, serviços e/ou negócios. Para concluir o diagnóstico, vamos entender como está sua percepção sobre empreender em um cenário que envolve o digital.")]),_c('p'),_c('p',[_vm._v("As questões a seguir abordam sobre disrupção, transformação cultural, produtividade e crescimento exponencial.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BOLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-media',
  props: {
    src: String
  }
});

/***/ }),

/***/ "CEyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('opacity', {
  bind: function bind(el, binding) {
    var element = el;
    element.classList.add('v-opacity');
    element.style.opacity = binding.value ? 1 : 0;
  },
  update: function update(el, binding) {
    var element = el;
    element.style.opacity = binding.value ? 1 : 0;
  }
});

/***/ }),

/***/ "CU+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-nav',
  props: {
    back: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scrollTo: function scrollTo(id) {
      var scrollY = document.getElementById(id).offsetTop - 24;
      window.$scrollTo(scrollY);
    }
  }
});

/***/ }),

/***/ "CpKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("998L");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'process-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'process',
      questions: [{ field: 'td_tech', title: 'O departamento comercial utiliza a tecnologia para aumentar resultados, seja através de novas ferramentas, discurso de vendas aprimorado ao consumidor ou controle de processo feito digitalmente.' }, { field: 'td_mkt', title: 'O marketing da empresa ganhou escalabilidade e previsibilidade com ações digitais, gerando leads qualificados e os nutre de forma automatizada até a chegada ao comercial.' }, { field: 'td_hr', title: 'O RH ganhou agilidade com processos digitais, automatizando tarefas de processos seletivos, análises de performance, folhas de pagamento, dentre outras.' }, { field: 'td_finance', title: 'O departamento financeiro utiliza tecnologia de maneira eficaz para redução de custos, agilidade em processos, melhor gestão financeira da empresa, dentre outras benéfices.' }, { field: 'td_it', title: 'O departamento de TI tem genuína preocupação em ir além do "básico" em TI, atuando de forma a reduzir custos e ganhar agilidade em todos os setores da empresa através da tecnologia e novas metodologias (DevOps), sendo o catalizador da transformação digital na empresa.' }, { field: 'td_legal', title: 'O departamento jurídico / administrativo reduziu consideravelmente seu esforço humano com o uso da tecnologia em tarefas burocráticas como emissão de relatórios, lançamento em sistemas, controle de documentos, dentre outras.' }, { field: 'td_goal_setting', title: 'A empresa possui metas claras com foco no digital para cenários em curto, médio e longo prazo.' }, { field: 'td_risk_profile', title: 'A empresa é adepta a riscos - ou seja, busca se adaptar às mutações do mercado e do consumidor independente de suas operações atuais.' }, { field: 'td_change', title: 'A empresa implementa mudanças, independente de sua magnitude, de forma ágil.' }, { field: 'td_tooling', title: 'A empresa disponibiliza as ferramentas digitais ideais para o desenvolvimento das funções de cada colaborador.' }, { field: 'td_automation', title: 'A empresa tem obtido sucesso na redução de trabalhos extremamente manuais realizados por pessoas da equipe.' }, { field: 'td_tech_inovation', title: 'A empresa busca constantemente novas tecnologias para otimizar seus processos.' }]
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
});

/***/ }),

/***/ "DR4r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideHorizontal_vue__ = __webpack_require__("pxyh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d549be28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideHorizontal_vue__ = __webpack_require__("M6/Z");
function injectStyle (ssrContext) {
  __webpack_require__("YFvj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d549be28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideHorizontal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d549be28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideHorizontal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DiNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'question',
  props: {
    number: Number,
    field: String,
    reverse: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    title: String
  },
  data: function data() {
    var value = this.value;
    if (this.reverse) {
      value = 100 - value;
    }
    return {
      input: value,
      answer: 'Sem Resposta',
      answerClass: 'grey-dark'
    };
  },
  mounted: function mounted() {
    var value = this.value;
    if (this.reverse) {
      value = 100 - value;
    }
  },

  methods: {
    changeInput: function changeInput(value) {
      if (this.reverse) {
        this.$emit('input', 100 - value, this.field);
      } else {
        this.$emit('input', value, this.field);
      }

      switch (true) {
        case value <= 25:
          this.answer = 'Discordo totalmente';
          this.answerClass = 'grey';
        case value <= 25:
          this.answer = 'Discordo totalmente';
          this.answerClass = 'grey';
          break;
        case value <= 50:
          this.answer = 'Discordo em partes';
          this.answerClass = 'grey';
          break;
        case value <= 75:
          this.answer = 'Concordo em partes';
          this.answerClass = 'green';
          break;
        case value <= 100:
          this.answer = 'Concordo totalmente';
          this.answerClass = 'green';
          break;
        default:
          this.answer = 'N/A';
          this.answerClass = 'grey-dark';
      }
    }
  }
});

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BAR_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUBMITTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALCULATE_OVERALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TEST_CALCULATE_OVERALL; });
var SET_BAR_PROGRESS = 'SET_BAR_PROGRESS';
var REQUEST_ERROR = 'REQUEST_ERROR';
var UPDATE_FIELD = 'UPDATE_FIELD';
var SUBMITTED = 'SUBMITTED';
var CALCULATE_OVERALL = 'CALCULATE_OVERALL';
var TEST_CALCULATE_OVERALL = 'TEST_CALCULATE_OVERALL';

/***/ }),

/***/ "ECk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"networks-social"},[_c('a',{attrs:{"href":"https://www.facebook.com/portaltransformacaodigital","target":"_blank"}},[_vm._v("Facebook")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/transformacao_digital","target":"_blank"}},[_vm._v("Instagram")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/company-beta/22291584/","target":"_blank"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.youtube.com/channel/UCk0lFSCTsTzZkK_dF5rXxYw","target":"_blank"}},[_vm._v("Youtube")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EFEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


function resultQuestions(formQuestions) {
  var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(formQuestions);
  var sumPoints = 0;
  for (var i = 0; i < keys.length; i += 1) {
    sumPoints += formQuestions[keys[i]];
  }
  return Math.ceil(sumPoints / keys.length);
}

var questionsVuex = {
  data: function data() {
    return {
      confirmEmail: this.$store.state.diagnosis.email,
      form: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$store.state[this.keyForm])
    };
  },

  methods: {
    rangeChange: function rangeChange(newValue, id) {
      this.form[id] = newValue;
      this.$store.commit('UPDATE_FIELD', {
        form: this.keyForm,
        key: id,
        value: newValue
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    console.log(this.keyForm, this.form, resultQuestions(this.form));
    this.$store.commit('UPDATE_FIELD', {
      form: 'results',
      key: 'td_score_' + this.keyForm,
      value: resultQuestions(this.form)
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (questionsVuex);

/***/ }),

/***/ "EQVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide-vertical',
  data: function data() {
    return {
      slideVertical: 'people'
    };
  },

  methods: {
    changeVertical: function changeVertical(name) {
      this.slideVertical = name;
    },
    isSlide: function isSlide(name) {
      return this.slideVertical === name;
    }
  }
});

/***/ }),

/***/ "Fdy6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"Cliente","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/processos/formulario","next":"/estrategia"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderNav__ = __webpack_require__("k1aN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vButton__ = __webpack_require__("wCtQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SlideVertical__ = __webpack_require__("KD3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SlideHorizontal__ = __webpack_require__("DR4r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vFooter__ = __webpack_require__("4FHn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import vVideo from './vVideo';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: { HeaderNav: __WEBPACK_IMPORTED_MODULE_0__HeaderNav__["a" /* default */], Icon: __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */], vButton: __WEBPACK_IMPORTED_MODULE_2__vButton__["a" /* default */], SlideVertical: __WEBPACK_IMPORTED_MODULE_3__SlideVertical__["a" /* default */], SlideHorizontal: __WEBPACK_IMPORTED_MODULE_4__SlideHorizontal__["a" /* default */], vFooter: __WEBPACK_IMPORTED_MODULE_5__vFooter__["a" /* default */] },
  data: function data() {
    return {
      loaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.loaded = true;
    }, 200);
    this.$store.commit('SET_BAR_PROGRESS', 0);
  }
});

/***/ }),

/***/ "GK9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalEntrepreneurshipForm_vue__ = __webpack_require__("pvIF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ca95e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalEntrepreneurshipForm_vue__ = __webpack_require__("QLd5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalEntrepreneurshipForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ca95e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalEntrepreneurshipForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GlIp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HT91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:{ half: _vm.half }},[(_vm.name === 'arrow-line-right')?_c('svg',{attrs:{"fill":_vm.color,"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 18","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.width ? _vm.width : '45px',"height":_vm.height}},[_c('path',{attrs:{"d":"M43.005,8.724 L35.720,16.009 L34.991 15.280 L41.276,8.995 L0.991,8.995 L0.991,8.005 L41.304,8.005 L35.148,1.848 L35.848,1.147 L42.849,8.148 L42.639,8.358 L43.005,8.724 Z"}})]):_vm._e(),_vm._v(" "),(_vm.name === 'arrow-right')?_c('svg',{attrs:{"viewBox":"0 0 41 80","width":_vm.width ? _vm.width : '41px',"height":_vm.height,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('path',{attrs:{"fill-rule":"evenodd","stroke":_vm.color,"stroke-width":"2px","stroke-linecap":"round","stroke-linejoin":"miter","fill":"none","d":"M2.007,1.990 L39.607,40.008 L2.007,78.025 "}})]):_vm._e(),_vm._v(" "),(_vm.name === 'arrow-small-down')?_c('svg',{attrs:{"viewBox":"0 0 100 100","width":_vm.width ? _vm.width : '56px',"height":_vm.height,"fill":_vm.color,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('polygon',{attrs:{"points":"73.4,50.4 75,51.9 48.8,78 22.6,51.9 24.2,50.4 47.7,73.9 47.7,20.2 49.9,20.2 49.9,73.9 "}})]):_vm._e(),_vm._v(" "),(_vm.name === 'arrow-line-middle')?_c('svg',{attrs:{"viewBox":"0 0 100 100","width":_vm.width ? _vm.width : '32px',"height":_vm.height,"fill":_vm.color,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('polygon',{attrs:{"points":"72.2,50.2 48.7,73.7 50.2,75.3 76.4,49.1 50.2,22.9 48.7,24.5 72.2,48 0,48 0,50.2 "}})]):_vm._e(),_vm._v(" "),(_vm.name === 'td-logo')?_c('svg',{attrs:{"width":"146px","height":"30px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 686.3 240"}},[_c('path',{attrs:{"d":"M0,0h322.3v58.9H0V0z M131.7,100.7V240h58.9V100.7H131.7z M686.3,120c0-13.8-2.9-26.8-8.3-38.6\n  c-3.7-8.2-8.5-15.8-14.3-22.5l0,0c-1.8-2.1-29-31.1-29-31.1C617.8,10,594.3,0,569.8,0H364.1v58.9h199.4c12.5,0,24.5,5.1,33.2,14.2\n  l19.5,20.4l0,0c6.1,7.1,9.8,16.3,9.8,26.4c0,10-3.7,19.2-9.7,26.3l0,0l-19.6,20.6C588,175.9,576,181,563.5,181H364.1v58.9h205.8\n  c24.5,0,48-10,64.9-27.8c0,0,27.2-28.9,29-31.1c5.8-6.7,10.6-14.3,14.3-22.5C683.4,146.9,686.3,133.8,686.3,120L686.3,120\n  L686.3,120z"}})]):_vm._e(),_vm._v(" "),(_vm.name === 'rockcontent-logo')?_c('svg',{attrs:{"fill":_vm.color,"width":_vm.width ? _vm.width : '238px',"height":"34px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M237.506,11.778 C236.386,11.765 235.266,11.772 234.146,11.776 C233.939,11.776 233.732,11.799 233.466,11.815 C233.466,12.016 233.466,12.183 233.466,12.350 C233.466,15.514 233.466,18.677 233.466,21.841 C233.466,21.919 233.465,21.997 233.467,22.074 C233.497,23.255 233.824,23.564 235.048,23.566 C236.001,23.568 236.954,23.567 237.983,23.567 C237.983,24.362 237.991,25.212 237.970,26.063 C237.968,26.153 237.808,26.293 237.697,26.319 C235.901,26.749 234.082,26.925 232.255,26.569 C230.583,26.242 229.586,25.161 229.329,23.476 C229.238,22.877 229.189,22.268 229.186,21.663 C229.172,18.562 229.169,15.461 229.191,12.359 C229.194,11.885 229.028,11.743 228.559,11.725 C227.717,11.693 226.877,11.615 226.039,11.527 C225.923,11.515 225.735,11.344 225.732,11.242 C225.708,10.356 225.718,9.468 225.718,8.501 C225.980,8.501 226.215,8.501 226.450,8.501 C227.181,8.501 227.913,8.475 228.641,8.511 C229.089,8.533 229.192,8.366 229.186,7.975 C229.167,6.838 229.202,5.699 229.169,4.563 C229.155,4.083 229.322,3.945 229.808,3.959 C230.862,3.990 231.918,3.979 232.973,3.963 C233.342,3.958 233.483,4.057 233.475,4.438 C233.450,5.637 233.481,6.838 233.457,8.038 C233.450,8.418 233.588,8.514 233.962,8.508 C235.163,8.489 236.365,8.510 237.566,8.496 C237.879,8.492 238.001,8.587 237.996,8.893 C237.983,9.704 237.980,10.514 237.998,11.324 C238.005,11.676 237.854,11.782 237.506,11.778 ZM222.671,26.280 C221.584,26.255 220.496,26.257 219.408,26.280 C219.003,26.288 218.887,26.162 218.888,25.774 C218.902,22.064 218.904,18.355 218.888,14.645 C218.885,14.090 218.816,13.524 218.690,12.982 C218.480,12.081 217.855,11.628 216.896,11.539 C215.331,11.392 213.883,11.842 212.441,12.320 C211.337,12.687 211.342,12.701 211.342,13.829 C211.342,17.803 211.335,21.778 211.351,25.752 C211.354,26.167 211.231,26.289 210.807,26.280 C209.720,26.256 208.632,26.264 207.544,26.276 C207.218,26.280 207.088,26.183 207.088,25.849 C207.097,20.191 207.094,14.533 207.096,8.876 C207.096,8.770 207.117,8.665 207.133,8.516 C208.483,8.516 209.779,8.516 211.134,8.516 C211.154,8.951 211.173,9.374 211.198,9.896 C211.546,9.721 211.825,9.580 212.105,9.441 C213.871,8.565 215.714,7.956 217.733,8.046 C219.174,8.109 220.580,8.319 221.683,9.350 C222.515,10.128 222.882,11.121 223.027,12.185 C223.148,13.078 223.221,13.982 223.226,14.883 C223.248,18.499 223.227,22.115 223.246,25.731 C223.248,26.169 223.110,26.290 222.671,26.280 ZM202.271,18.665 C198.570,18.665 194.870,18.665 191.169,18.666 C190.508,18.666 190.495,18.667 190.515,19.315 C190.528,19.750 190.549,20.189 190.626,20.617 C190.898,22.131 191.811,23.014 193.529,23.162 C195.072,23.295 196.634,23.270 198.186,23.230 C199.495,23.196 200.800,23.041 202.189,22.933 C202.189,23.585 202.189,24.231 202.189,24.876 C202.189,26.033 202.187,26.021 201.004,26.245 C198.507,26.719 195.985,26.855 193.454,26.673 C192.512,26.606 191.561,26.405 190.657,26.132 C188.487,25.477 187.182,23.980 186.702,21.890 C186.042,19.015 185.976,16.107 186.739,13.242 C187.566,10.134 189.910,8.365 193.235,8.110 C194.539,8.010 195.822,8.030 197.101,8.294 C199.687,8.828 201.384,10.327 202.266,12.693 C202.978,14.604 203.030,16.589 202.946,18.665 C202.687,18.665 202.479,18.665 202.271,18.665 ZM198.623,14.599 C198.503,12.918 197.530,11.729 195.938,11.488 C195.105,11.362 194.217,11.353 193.385,11.479 C191.412,11.778 189.993,14.172 190.648,15.964 C193.302,15.964 195.956,15.964 198.628,15.964 C198.628,15.491 198.655,15.043 198.623,14.599 ZM183.507,11.779 C182.370,11.764 181.234,11.772 180.098,11.776 C179.908,11.777 179.719,11.802 179.487,11.819 C179.487,12.032 179.487,12.201 179.487,12.370 C179.487,15.518 179.486,18.666 179.487,21.814 C179.488,23.314 179.756,23.567 181.334,23.567 C182.191,23.567 183.049,23.567 183.973,23.567 C183.981,23.637 184.009,23.784 184.011,23.933 C184.017,24.385 184.020,24.837 184.012,25.289 C183.995,26.473 184.178,26.240 183.036,26.471 C181.536,26.774 180.017,26.863 178.494,26.607 C176.705,26.305 175.629,25.253 175.353,23.502 C175.258,22.905 175.210,22.295 175.207,21.690 C175.193,18.589 175.201,15.487 175.200,12.386 C175.200,11.767 175.192,11.773 174.558,11.731 C173.718,11.676 172.877,11.612 172.039,11.528 C171.931,11.517 171.755,11.361 171.753,11.269 C171.731,10.369 171.740,9.468 171.740,8.510 C172.892,8.510 174.003,8.510 175.154,8.510 C175.173,8.258 175.198,8.060 175.199,7.862 C175.203,6.724 175.212,5.587 175.195,4.449 C175.189,4.082 175.324,3.957 175.703,3.963 C176.807,3.980 177.911,3.982 179.015,3.962 C179.415,3.954 179.500,4.107 179.494,4.458 C179.475,5.658 179.499,6.858 179.480,8.058 C179.474,8.409 179.595,8.513 179.955,8.508 C181.140,8.490 182.325,8.515 183.509,8.494 C183.886,8.487 184.031,8.585 184.020,8.960 C183.997,9.739 183.998,10.519 184.020,11.297 C184.030,11.671 183.880,11.784 183.507,11.779 ZM168.719,26.280 C167.632,26.256 166.544,26.256 165.456,26.280 C165.035,26.289 164.905,26.170 164.907,25.753 C164.925,22.059 164.921,18.365 164.912,14.671 C164.912,14.221 164.876,13.767 164.804,13.323 C164.591,12.013 163.718,11.419 162.168,11.499 C160.575,11.582 159.090,12.072 157.630,12.638 C157.492,12.691 157.376,12.972 157.374,13.148 C157.354,14.784 157.362,16.421 157.362,18.057 C157.362,20.629 157.354,23.201 157.371,25.773 C157.374,26.158 157.265,26.288 156.856,26.280 C155.752,26.257 154.648,26.266 153.544,26.275 C153.243,26.277 153.110,26.192 153.110,25.875 C153.118,20.171 153.117,14.466 153.119,8.762 C153.119,8.700 153.136,8.640 153.153,8.524 C154.496,8.524 155.804,8.524 157.172,8.524 C157.172,8.955 157.172,9.368 157.172,9.881 C157.412,9.778 157.568,9.722 157.713,9.647 C159.252,8.854 160.846,8.221 162.608,8.075 C163.899,7.969 165.175,8.058 166.385,8.526 C168.097,9.188 168.814,10.559 169.050,12.205 C169.175,13.082 169.242,13.972 169.247,14.857 C169.268,18.488 169.249,22.120 169.266,25.751 C169.268,26.166 169.143,26.289 168.719,26.280 ZM142.812,26.587 C141.135,26.839 139.446,26.847 137.785,26.477 C134.816,25.814 133.056,23.983 132.498,21.145 C132.256,19.915 132.249,18.643 132.119,17.226 C132.257,16.013 132.289,14.632 132.588,13.306 C133.210,10.559 135.047,8.896 137.913,8.306 C139.812,7.915 141.712,7.931 143.597,8.389 C146.294,9.045 147.989,10.715 148.567,13.289 C149.178,16.005 149.171,18.774 148.572,21.492 C147.944,24.341 145.843,26.132 142.812,26.587 ZM144.542,14.672 C144.350,12.986 143.422,11.973 141.823,11.676 C141.317,11.583 140.789,11.549 140.275,11.566 C138.195,11.634 137.023,12.486 136.675,14.375 C136.306,16.376 136.336,18.411 136.670,20.419 C136.920,21.919 137.824,22.911 139.447,23.142 C140.019,23.224 140.612,23.226 141.190,23.188 C143.076,23.062 144.099,22.253 144.447,20.488 C144.644,19.486 144.648,18.450 144.718,17.664 C144.653,16.503 144.645,15.583 144.542,14.672 ZM129.163,26.213 C127.242,26.646 125.287,26.822 123.321,26.719 C122.409,26.671 121.473,26.534 120.610,26.259 C118.143,25.474 116.901,23.659 116.401,21.308 C116.002,19.431 116.041,17.523 116.157,15.628 C116.222,14.551 116.387,13.454 116.703,12.420 C117.429,10.042 119.182,8.668 121.692,8.240 C124.236,7.806 126.764,8.075 129.266,8.606 C129.400,8.635 129.612,8.767 129.614,8.855 C129.639,9.830 129.630,10.806 129.630,11.806 C128.543,11.734 127.529,11.636 126.512,11.606 C125.494,11.577 124.464,11.539 123.455,11.642 C121.851,11.806 120.939,12.626 120.647,14.179 C120.263,16.215 120.285,18.285 120.594,20.319 C120.899,22.324 122.061,23.228 124.214,23.249 C125.784,23.264 127.355,23.116 128.926,23.040 C129.133,23.030 129.340,23.014 129.635,22.995 C129.635,24.016 129.650,24.964 129.614,25.910 C129.610,26.019 129.335,26.174 129.163,26.213 ZM114.326,26.271 C113.011,26.273 111.695,26.255 110.381,26.282 C109.943,26.290 109.673,26.149 109.414,25.813 C107.451,23.255 105.467,20.711 103.488,18.163 C103.432,18.090 103.362,18.026 103.220,17.873 C103.206,18.120 103.189,18.277 103.189,18.434 C103.188,20.881 103.180,23.328 103.197,25.775 C103.200,26.162 103.086,26.289 102.680,26.280 C101.658,26.257 100.635,26.273 99.612,26.272 C98.942,26.271 98.941,26.270 98.941,25.640 C98.940,18.643 98.940,11.646 98.940,4.648 C98.940,3.684 98.940,2.719 98.940,1.701 C100.385,1.701 101.758,1.701 103.181,1.701 C103.181,6.576 103.181,11.429 103.181,16.427 C103.379,16.220 103.486,16.120 103.578,16.009 C105.563,13.623 107.550,11.238 109.522,8.843 C109.738,8.581 109.958,8.489 110.298,8.494 C111.580,8.513 112.863,8.501 114.146,8.501 C114.301,8.501 114.457,8.501 114.734,8.501 C112.310,11.386 109.962,14.180 107.575,17.019 C110.002,20.069 112.420,23.108 114.905,26.232 C114.653,26.249 114.489,26.270 114.326,26.271 ZM92.029,11.609 C90.995,11.581 89.950,11.543 88.925,11.645 C87.365,11.801 86.454,12.584 86.157,14.047 C85.722,16.187 85.733,18.361 86.113,20.501 C86.443,22.364 87.619,23.240 89.688,23.251 C91.242,23.259 92.796,23.120 94.349,23.045 C94.575,23.034 94.799,23.011 95.108,22.988 C95.108,23.670 95.108,24.317 95.108,24.964 C95.108,26.118 95.111,26.137 93.939,26.351 C91.826,26.739 89.695,26.906 87.557,26.611 C84.484,26.186 82.518,24.355 81.902,21.416 C81.450,19.257 81.552,17.074 81.691,14.902 C81.752,13.954 81.976,12.989 82.301,12.089 C83.118,9.835 84.879,8.608 87.288,8.223 C89.789,7.825 92.263,8.084 94.715,8.604 C94.862,8.635 95.085,8.806 95.088,8.917 C95.118,9.864 95.106,10.811 95.106,11.806 C94.030,11.734 93.031,11.638 92.029,11.609 ZM72.001,26.588 C70.278,26.858 68.545,26.839 66.835,26.427 C64.201,25.791 62.488,24.198 61.871,21.686 C61.185,18.899 61.192,16.056 61.834,13.261 C62.465,10.513 64.330,8.877 67.199,8.296 C69.037,7.924 70.877,7.928 72.696,8.349 C75.729,9.052 77.435,10.981 77.941,13.881 C78.144,15.040 78.151,16.232 78.248,17.409 C78.180,18.847 78.174,20.275 77.776,21.677 C76.967,24.532 74.981,26.119 72.001,26.588 ZM73.810,14.834 C73.654,13.087 72.724,12.003 71.088,11.684 C70.568,11.583 70.022,11.546 69.492,11.567 C67.320,11.654 66.222,12.564 65.868,14.625 C65.563,16.402 65.586,18.204 65.828,19.981 C66.097,21.952 66.929,22.826 68.660,23.133 C69.241,23.236 69.856,23.223 70.451,23.187 C72.313,23.072 73.404,22.172 73.708,20.422 C73.881,19.429 73.902,18.412 73.968,17.657 C73.908,16.543 73.886,15.686 73.810,14.834 ZM54.051,12.702 C53.639,12.796 53.505,13.025 53.506,13.440 C53.522,17.506 53.516,21.571 53.516,25.638 C53.516,26.270 53.514,26.272 52.848,26.272 C51.793,26.273 50.739,26.266 49.684,26.275 C49.382,26.278 49.255,26.193 49.256,25.876 C49.265,20.158 49.264,14.441 49.266,8.724 C49.266,8.678 49.277,8.632 49.293,8.527 C50.627,8.527 51.934,8.527 53.317,8.527 C53.317,8.961 53.317,9.384 53.317,9.963 C55.219,8.442 57.344,8.070 59.619,8.036 C59.619,9.305 59.619,10.527 59.619,11.768 C58.765,11.849 57.907,11.878 57.070,12.023 C56.054,12.199 55.057,12.474 54.051,12.702 ZM35.512,28.259 C33.639,31.397 30.754,33.125 27.095,33.681 C25.742,33.887 24.355,33.945 22.983,33.963 C19.931,34.003 16.878,34.005 13.827,33.964 C12.076,33.941 10.344,33.717 8.670,33.167 C5.046,31.977 2.747,29.533 1.434,26.153 C0.705,24.277 0.302,22.330 0.165,20.335 C0.076,19.048 -0.041,17.755 -0.007,16.469 C0.072,13.367 0.386,10.292 1.651,7.385 C3.469,3.205 6.747,0.800 11.409,0.306 C13.914,0.040 16.457,0.094 18.983,0.004 C18.985,0.035 18.985,0.066 18.987,0.098 C20.918,0.098 22.853,0.036 24.782,0.112 C28.038,0.238 31.054,1.059 33.486,3.290 C35.209,4.871 36.250,6.842 36.921,9.008 C37.532,10.984 37.856,13.009 37.899,15.069 C37.931,16.576 37.978,18.088 37.881,19.590 C37.685,22.621 37.114,25.576 35.512,28.259 ZM33.277,14.488 C33.207,12.848 33.089,11.192 32.774,9.582 C32.217,6.732 30.443,4.822 27.474,4.099 C26.322,3.818 25.118,3.665 23.930,3.606 C22.295,3.524 20.652,3.585 19.013,3.585 C19.013,3.583 19.013,3.581 19.013,3.579 C17.536,3.579 16.056,3.530 14.582,3.594 C13.375,3.646 12.154,3.742 10.973,3.977 C7.929,4.582 5.919,6.329 5.252,9.278 C4.928,10.712 4.756,12.193 4.696,13.660 C4.606,15.885 4.614,18.118 4.694,20.343 C4.745,21.765 4.895,23.200 5.190,24.593 C5.790,27.428 7.592,29.297 10.542,29.967 C11.931,30.283 13.385,30.427 14.816,30.468 C17.492,30.545 20.172,30.530 22.850,30.473 C24.187,30.445 25.539,30.340 26.851,30.099 C29.917,29.536 31.986,27.818 32.679,24.848 C33.026,23.358 33.188,21.812 33.267,20.283 C33.366,18.355 33.359,16.417 33.277,14.488 ZM27.677,24.385 C27.542,25.320 26.794,25.952 25.810,25.954 C21.186,25.961 16.562,25.961 11.938,25.954 C10.814,25.952 10.018,25.170 10.004,24.098 C10.000,23.739 10.026,23.379 9.997,23.023 C9.966,22.635 10.117,22.513 10.520,22.515 C12.824,22.530 15.128,22.523 17.431,22.522 C17.918,22.522 18.405,22.522 18.891,22.523 C21.650,22.523 24.408,22.531 27.166,22.513 C27.626,22.511 27.823,22.623 27.767,23.086 C27.715,23.516 27.739,23.956 27.677,24.385 ZM10.520,15.320 C12.825,15.320 15.130,15.320 17.435,15.320 C17.923,15.320 18.409,15.320 18.897,15.320 C21.656,15.320 24.416,15.330 27.176,15.310 C27.651,15.307 27.793,15.446 27.772,15.894 C27.736,16.656 27.735,17.422 27.772,18.184 C27.793,18.634 27.646,18.766 27.175,18.765 C22.061,18.750 16.947,18.756 11.833,18.756 C11.346,18.756 10.859,18.748 10.372,18.756 C10.101,18.761 9.998,18.651 10.001,18.393 C10.009,17.489 10.015,16.585 9.999,15.681 C9.992,15.286 10.256,15.320 10.520,15.320 ZM27.274,11.628 C25.197,11.611 23.120,11.620 21.043,11.620 C20.329,11.620 19.616,11.620 18.902,11.620 C16.111,11.620 13.320,11.614 10.529,11.628 C10.139,11.629 9.962,11.540 9.997,11.136 C10.028,10.765 10.000,10.389 10.005,10.015 C10.020,8.926 10.840,8.137 11.977,8.137 C16.488,8.133 20.999,8.159 25.509,8.118 C26.639,8.108 27.707,8.725 27.759,10.213 C27.771,10.525 27.739,10.838 27.767,11.148 C27.801,11.518 27.664,11.631 27.274,11.628 Z"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HXKR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("998L");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'peoples-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'people',
      questions: [{ field: 'td_maturity', value: 0, title: 'A cultura da minha empresa é ser digital. Quando concebemos uma ideia, um projeto ou uma estratégia, desde o início já temos em mente como isso será construído no meio digital.' }, { field: 'td_leadership_buy_in', value: 0, title: 'Os líderes da minha empresa entendem a magnitude do digital e impulsionam cultura e mudanças nesta direção.' }, { field: 'td_value', value: 0, title: 'A empresa tem plena consciência da mudança que o digital trará nas competências necessárias para seus colaboradores.' }, { field: 'td_employee_readiness', value: 0, title: 'Os colaboradores da empresa possuem as habilidades necessárias para se adaptar às mudanças que o digital está trazendo.' }, { field: 'td_employee_profile', value: 0, title: 'Acredito que a empresa possui as pessoas certas para conduzir processos relacionados à transformação digital.' }, { field: 'td_communication', value: 0, title: 'A comunicação e transmissão de informação entre os colaboradores de diferentes departamentos é realizada de forma eficiente no ambiente digital.' }, { field: 'td_openness', value: 0, title: 'A empresa se demonstra aberta para inovações por parte dos funcionários relacionadas ao ambiente digital.' }, { field: 'td_inovation', value: 0, title: 'A empresa viabiliza e põe em prática inovações sugeridas por funcionários relacionadas ao ambiente digital.' }]
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
});

/***/ }),

/***/ "IWEL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__("mUbh");








__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (function (dataState) {

  var state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    barProgress: 0,
    requestError: false,
    submitted: false,
    diagnosis: {
      industry: '',
      firstname: '',
      email: '',
      business_model: '',
      estado_sigla: '',
      company: '',
      numemployees: '',
      td_cargo: '',
      clevel_funcao: '',
      departamento: '',
      papel_td: ''
    },
    userid: '',
    usercode: '',
    username: '',
    questions: {
      cultura_e_lideranca: [{ field: 'cultura_e_lideranca_1', weight: 1, tag: 'Mindset', title: 'Estou convencido que o processo de transformação digital é um efeito global e impacta não somente empresas, mas o cotidiano das pessoas.' }, { field: 'cultura_e_lideranca_2', weight: 2, tag: 'Mindset', title: 'Tenho consciência dos fatores que envolvem a transformação digital quando falamos em ferramentas, processos e pessoas.' }, { field: 'cultura_e_lideranca_3', weight: 2, reverse: true, tag: 'Mindset', title: 'Percebo que as habilidades necessárias para atuar na transformação digital pertecem somente à geração dos Millennials.' }, { field: 'cultura_e_lideranca_4', weight: 1, reverse: true, tag: 'Inovação', title: 'Prefiro ser reconhecido como um profissional que traz segurança por seguir processos lineares do que como um agente de mudanças disposto a testar novos modelos com frequencia.' }, { field: 'cultura_e_lideranca_5', weight: 3, tag: 'Liderança', title: 'Identifico com facilidade processos críticos do meu ambiente de trabalho e busco alternativas viáveis em conjunto com a equipe.' }, { field: 'cultura_e_lideranca_6', weight: 2, tag: 'Mindset', title: 'Costumo interagir com meus colegas de trabalho a fim de compartilhar conhecimentos e favorecer um ambiente de crescimento colaborativo.' }, { field: 'cultura_e_lideranca_7', weight: 3, reverse: true, tag: 'Liderança', title: 'Na posição de líder, optaria por desenhar estratégias de acordo com padrões analógicos e de conhecimento do time, ao invés de provar modelos digitais ainda não habituais.' }],
      agilidade_operacional: [{ field: 'agilidade_operacional_1', weight: 3, tag: 'Ferramentas', title: 'Considero frequentemente o uso de ferramentas digitais nos processos operacionais, visando redução de custos, agilidade ou melhor gestão de recursos.' }, { field: 'agilidade_operacional_2', weight: 2, tag: 'Metodologias ágeis', title: 'Utilizo recursos como mapas mentais para visualizar com mais clareza os pontos de atenção de um projeto.' }, { field: 'agilidade_operacional_3', weight: 3, tag: 'Ferramentas', title: 'Sempre que possível opto por ferramentas com recursos de automação que possam substituir processos manuais e/ou repetitivos.' }, { field: 'agilidade_operacional_4', weight: 1, reverse: true, tag: 'Mindset', title: 'Me sinto mais confortável trabalhando em projetos com rotinas fixas e pré-estabelecidas no longo prazo do que com projetos modulares de curta e média duração.' }, { field: 'agilidade_operacional_5', weight: 2, tag: 'Metodologias ágeis', title: 'Estudo com frequencia métodos e alternativas práticas para implementar mudanças de maneira mais ágil.' }, { field: 'agilidade_operacional_6', weight: 1, tag: 'Metodologias ágeis', title: 'Em vista de resolver determinados problemas considero viável reunir pessoas de departamentos distintos para formar uma nova equipe.' }, { field: 'agilidade_operacional_7', weight: 1, reverse: true, tag: 'Mindset', title: 'Percebo que a reavaliação de processos em períodos pré-determinados ocasionam desperdício de tempo e prejudicam a eficiência.' }],
      tecnologia_digital: [{ field: 'tecnologia_digital_1', weight: 1, tag: 'Análise de dados', title: 'Entendo o impacto que a coleta, estruturação e leitura inteligente de dados podem ocasionar em meu trabalho.' }, { field: 'tecnologia_digital_2', weight: 3, tag: 'KPI\'s', title: 'Em cada projeto que executo tenho mapeados os indicadores de sucesso das ações.' }, { field: 'tecnologia_digital_3', weight: 2, tag: 'Cloud computing', title: 'Sei dos benefícios que o armazenamento de dados na nuvem (cloud computing) podem trazer para meu trabalho.' }, { field: 'tecnologia_digital_4', weight: 1, tag: 'Segurança de dados', title: 'Prezo pela segurança digital dos arquivos que temos armazenados, seguindo as orientações do time de TI.' }, { field: 'tecnologia_digital_5', weight: 2, reverse: true, tag: 'IoT e Impressão 3D', title: 'Não vejo aplicações reais da Internet das Coisas e da impressão 3D, sendo tecnologias que devem cair em desuso nos próximos anos.' }, { field: 'tecnologia_digital_6', weight: 3, tag: 'Análise de dados', title: 'Tomo decisões com base em sistemas analíticos, utilizando análise de dados para construção de estratégias.' }, { field: 'tecnologia_digital_7', weight: 1, reverse: true, tag: 'Gestão da informação', title: 'É melhor controlar as informações da empresa em documentos do Word e planilhas segmentadas do Excel do que compilar tudo em um único ambiente.' }],
      experiencia_do_cliente: [{ field: 'experiencia_do_cliente_1', weight: 2, tag: 'Metodologias ágeis', title: 'Acredito que testar possíveis soluções para nossos clientes, despendendo recursos em protótipos simplificados, pode tornar nossos produtos mais lucrativos.' }, { field: 'experiencia_do_cliente_2', weight: 3, tag: 'Personas', title: 'Tenho mapeadas as necessidades das personas da empresa e sei quais soluções oferecer para cada perfil de cliente, aumentando a geração de valor do meu produto.' }, { field: 'experiencia_do_cliente_3', weight: 3, reverse: true, tag: 'Gamificação', title: 'As dinâmicas de gamificação prejudicam o engajamento dos clientes, geralmente dificultando o processo de retenção.' }, { field: 'experiencia_do_cliente_4', weight: 2, tag: 'Jornada do Cliente', title: 'Entendo os hábitos de consumo dos meus clientes e levo isso em consideração para proporcionar uma melhor experiência durante a jornada do consumidor.' }, { field: 'experiencia_do_cliente_5', weight: 2, reverse: true, tag: 'Mindset', title: 'Considero que a preocupação com melhorias no produto dispersa a equipe de pós-vendas.' }, { field: 'experiencia_do_cliente_6', weight: 1, tag: 'Ferramentas', title: 'O uso de uma plataforma de atendimento omnichannel pode contribuir com o aumento das vendas e/ou retenção de clientes.' }, { field: 'experiencia_do_cliente_7', weight: 1, tag: 'Análise de dados', title: 'Administrar os dados dos clientes em uma plataforma digital favorece a análise do comportamento do usuário.' }],
      empreendedorismo_digital: [{ field: 'empreendedorismo_digital_1', weight: 2, tag: 'Empresas digitais', title: 'Do ponto de vista de um negócio digital, entendo com clareza a aplicação dos termos: escala, alcance e velocidade.' }, { field: 'empreendedorismo_digital_2', weight: 1, tag: 'Disrupção', title: 'Encaro a disrupção como algo natural dos mercados e produtos, sendo uma oportunidade para novas ideias.' }, { field: 'empreendedorismo_digital_3', weight: 1, reverse: true, tag: 'Crescimento Exponencial', title: 'Prefiro considerar um crescimento linear, onde consigo prever até onde vai o negócio, do que as variáveis para um crescimento exponencial.' }, { field: 'empreendedorismo_digital_4', weight: 1, tag: 'Parcerias estratégicas', title: 'Procuro expandir minha rede de contatos constantemente, tendo em vista possíveis parcerias estratégicas.' }, { field: 'empreendedorismo_digital_5', weight: 3, tag: 'Produtividade', title: 'Tenho atenção constante com o meu nível de produtividade, encontrando mecanismos para gestão de tempo e performance.' }, { field: 'empreendedorismo_digital_6', weight: 2, reverse: true, tag: 'Cultura digital', title: 'Entendo que o desenvolvimento de uma cultura digital dentro do negócio se resume à contratação de ferramentas digitais.' }, { field: 'empreendedorismo_digital_7', weight: 3, tag: 'Empresas digitais', title: 'Sempre observo o que acontece no mercado como uma maneira de encontrar oportunidades ou prever riscos.' }]
    },
    cultura_e_lideranca: {
      cultura_e_lideranca_1: 0,
      cultura_e_lideranca_2: 0,
      cultura_e_lideranca_3: 100,
      cultura_e_lideranca_4: 100,
      cultura_e_lideranca_5: 0,
      cultura_e_lideranca_6: 0,
      cultura_e_lideranca_7: 100
    },
    experiencia_do_cliente: {
      experiencia_do_cliente_1: 0,
      experiencia_do_cliente_2: 0,
      experiencia_do_cliente_3: 100,
      experiencia_do_cliente_4: 0,
      experiencia_do_cliente_5: 100,
      experiencia_do_cliente_6: 0,
      experiencia_do_cliente_7: 0
    },
    empreendedorismo_digital: {
      empreendedorismo_digital_1: 0,
      empreendedorismo_digital_2: 0,
      empreendedorismo_digital_3: 100,
      empreendedorismo_digital_4: 0,
      empreendedorismo_digital_5: 0,
      empreendedorismo_digital_6: 100,
      empreendedorismo_digital_7: 0
    },
    tecnologia_digital: {
      tecnologia_digital_1: 0,
      tecnologia_digital_2: 0,
      tecnologia_digital_3: 0,
      tecnologia_digital_4: 0,
      tecnologia_digital_5: 100,
      tecnologia_digital_6: 0,
      tecnologia_digital_7: 100
    },
    agilidade_operacional: {
      agilidade_operacional_1: 0,
      agilidade_operacional_2: 0,
      agilidade_operacional_3: 0,
      agilidade_operacional_4: 100,
      agilidade_operacional_5: 0,
      agilidade_operacional_6: 0,
      agilidade_operacional_7: 100
    },
    test_results: {
      cultura_e_lideranca: 0,
      agilidade_operacional: 0,
      tecnologia_digital: 0,
      experiencia_do_cliente: 0,
      empreendedorismo_digital: 0,
      overall: 0
    },
    understanding: {
      td_understanding: 0,
      td_understanding_corp: 0,
      td_readiness: 0,
      td_investment: 0
    },
    people: {
      td_maturity: 0,
      td_leadership_buy_in: 0,
      td_value: 0,
      td_employee_readiness: 0,
      td_employee_profile: 0,
      td_communication: 0,
      td_openness: 0,
      td_inovation: 0
    },
    process: {
      td_tech: 0,
      td_mkt: 0,
      td_hr: 0,
      td_finance: 0,
      td_it: 0,
      td_legal: 0,
      td_goal_setting: 0,
      td_risk_profile: 0,
      td_change: 0,
      td_tooling: 0,
      td_automation: 0,
      td_tech_inovation: 0
    },
    customer_experience: {
      td_cust_understanding: 0,
      td_cust_focus: 0,
      td_cust_data: 0,
      td_biz_model: 0,
      td_tech_adoption: 0,
      td_experimentation: 0,
      td_digital_delivery: 0
    },
    strategy: {
      td_strategy_infra: 0,
      td_digital_first: 0,
      td_measurement: 0,
      td_security: 0,
      td_team_readyness: 0,
      td_communication_clarity: 0,
      td_goal_solution: 0,
      td_data_unity: 0
    },
    results: {
      td_score_understanding: 0,
      td_score_people: 0,
      td_score_process: 0,
      td_score_customer_experience: 0,
      td_score_strategy: 0,
      td_score_overall: 0
    }
  }, dataState);

  var getters = {
    data: function data() {
      var questions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.understanding, state.people, state.process, state.customer_experience, state.strategy, state.cultura_e_lideranca, state.experiencia_do_cliente, state.empreendedorismo_digital, state.empreendedorismo_digital, state.tecnologia_digital, state.agilidade_operacional);
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(questions);
      for (var i = 0; i < keys.length; i += 1) {
        var value = questions[keys[i]];

        if (value === 0) {
          questions[keys[i]] = 'N/A';
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(questions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.diagnosis, state.results));
    }
  };

  return new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
    state: state,
    getters: getters,
    mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* mutations */],
    actions: __WEBPACK_IMPORTED_MODULE_6__actions__
  });
});

/***/ }),

/***/ "J8yv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-abstract block-fullscreen",class:{ 'is-mobile': _vm.mobile }},[_c('div',{staticClass:"header-logo",attrs:{"id":"headerLogo"}},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center result-page"},[_c('div',{attrs:{"id":"fullpage"}},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"result-percentage result-big bg-abstract-float"},[_c('h1',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.overall.title))]),_vm._v(" "),_c('div',{staticClass:"number-float"},[_vm._v(_vm._s(_vm.initResults.td_score_overall)+"%")])]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down",attrs:{"href":("#" + (_vm.slidesNames[1]))}},[_c('div',{staticClass:"title hidden-xs hidden-sm"},[_vm._v("\n            Role para baixo\n          ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"result-bar"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.resultText.overall.text)}}),_vm._v(" "),_c('div',{staticClass:"categories-bars"},[_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("Pessoas")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.td_score_people))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.td_score_people)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("Processos")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.td_score_process))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.td_score_process)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("Cliente")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.td_score_customer_experience))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.td_score_customer_experience)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("Estratégia")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.td_score_strategy))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.td_score_strategy)+"%")])])])]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down hidden-xs",attrs:{"href":("#" + (_vm.slidesNames[2]))}},[_c('icon',{staticClass:"animation-blink",attrs:{"name":"arrow-small-down"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section result-categories"},[_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("Pessoas")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.people.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultPeople"}},[_vm._v(_vm._s(_vm.initResults.td_score_people)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.people.text)}})]),_vm._v(" "),_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("Processos")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.process.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultProcess"}},[_vm._v(_vm._s(_vm.initResults.td_score_process)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.process.text)}})]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down hidden-xs",attrs:{"href":("#" + (_vm.slidesNames[3]))}},[_c('icon',{staticClass:"animation-blink",attrs:{"name":"arrow-small-down"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section result-categories"},[_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("Exp. do Consumidor")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.customer_experience.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultPeople"}},[_vm._v(_vm._s(_vm.initResults.td_score_customer_experience)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.customer_experience.text)}})]),_vm._v(" "),_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("Estratégia")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.strategy.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultProcess"}},[_vm._v(_vm._s(_vm.initResults.td_score_strategy)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.strategy.text)}})]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down hidden-xs",attrs:{"href":("#" + (_vm.slidesNames[4]))}},[_c('icon',{staticClass:"animation-blink",attrs:{"name":"arrow-small-down"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"result-share"},[_c('h1',{staticClass:"title"},[_vm._v("Compartilhe seu resultado")]),_vm._v(" "),_c('div',{staticClass:"networks-social"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.shareFaceBook($event)}}},[_vm._v("Facebook")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.shareTwitterUrl,"target":"_blank"}},[_vm._v("Twitter")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.shareLinkedinUrl,"target":"_blank"}},[_vm._v("Linkedin")])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-link"},[_c('a',{attrs:{"href":"https://transformacaodigital.com/contato","target":"_blank"}},[_vm._v("Contate-nos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JHQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-default screen-home"},[_c('header-nav',[_c('div',{staticClass:"header-center"},[_c('div',{staticClass:"header-logos"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("xrWu"),"alt":"TD Score"}}),_vm._v(" "),_c('icon',{staticClass:"logo",attrs:{"name":"rockcontent-logo"}})],1),_vm._v(" "),_c('h1',{directives:[{name:"opacity",rawName:"v-opacity",value:(_vm.loaded),expression:"loaded"}],staticClass:"header-title"},[_vm._v("Score")]),_vm._v(" "),_c('h2',{staticClass:"header-subtitle"},[_vm._v("Índice de maturidade digital")]),_vm._v(" "),_c('v-button',{attrs:{"to":"/intro","big":"","arrow":"","outline":""}},[_vm._v("Inicie o diagnóstico")])],1),_vm._v(" "),_c('div',{staticClass:"line-vertical-small"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('section',{staticClass:"insights-result",attrs:{"id":"como-funciona"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("insights de resultado")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"description"},[_c('div',[_vm._v("Através de questionários simples, o TD Score oferece o resultado do desempenho atual da sua empresa e indicadores dos próximos passos a serem dados, baseado em 4 dimensões que respondem pela organização como um todo: Pessoas, Processos, Cliente e Estratégia.")]),_vm._v(" "),_c('v-button',{attrs:{"to":"/intro","dark":"","outline":""}},[_vm._v("Descubra o seu score")])],1),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"container slide-vertical-home"},[_c('slide-vertical')],1),_vm._v(" "),_c('slide-horizontal',{attrs:{"id":"new-strategy"}}),_vm._v(" "),_c('v-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"box-white-float"},[_c('h1',{staticClass:"title"},[_vm._v("\n      Descubra o avanço da transformação "),_c('br'),_vm._v(" Digital em sua empresa\n    ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("\n      Uma ferramenta totalmente gratuita feita para você diagnosticar o índice de maturidade digital da sua organização em apenas alguns minutos.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media"},[_c('video',{attrs:{"width":"100%","autoplay":"","loop":"","src":__webpack_require__("vaXp")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K5i+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'process',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/processos/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
});

/***/ }),

/***/ "KCbc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KD3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideVertical_vue__ = __webpack_require__("EQVk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2376fa6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideVertical_vue__ = __webpack_require__("b66r");
function injectStyle (ssrContext) {
  __webpack_require__("XXpS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2376fa6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideVertical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2376fa6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideVertical_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KeHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("Cliente")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("Atualmente, temos acesso a tanta informação - por vontade própria ou não - que se faz necessário um grande esforço das marcas para captar nossa atenção. Na maioria das vezes, marcas que se destacam no gosto de seu público são as que oferecem as melhores experiências para seus consumidores. Este movimento em prol da experiência se tornou tão forte que podemos colocá-lo como um dos objetivos finais da Transformação Digital.")]),_vm._v(" "),_c('p',[_vm._v("E a sua empresa? Utiliza seus recursos humanos e tecnológicos para buscar melhoria na experiência do consumidor?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KfN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("bQkl");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cultura_e_lideranca-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'cultura_e_lideranca',
      questions: this.$store.state.questions.cultura_e_lideranca
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
});

/***/ }),

/***/ "KqHe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/youaredigital.aa78f00.mp4";

/***/ }),

/***/ "M6/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"slide-horizontal"},[_c('h1',{staticClass:"title"},[_vm._v("Desbrave novas estratégias")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"slide-area"},[_c('a',{staticClass:"nav-arrow nav-left",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.prevItem()}}},[_c('icon',{attrs:{"name":"arrow-right","half":""}})],1),_vm._v(" "),_c('div',{staticClass:"slide-wrap"},[_c('transition',{attrs:{"name":_vm.slideTransition,"mode":"out-in"}},[(_vm.current == 1)?_c('div',{key:"1",staticClass:"slide-item"},[_c('a',{staticClass:"slide-media",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showItem(_vm.videos.VideoForm)}}},[_c('video',{attrs:{"height":"100%","autoplay":"","loop":"","src":_vm.videos.VideoForm}})]),_vm._v(" "),_c('a',{staticClass:"slide-media",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showItem(_vm.videos.VideoResult)}}},[_c('video',{attrs:{"height":"100%","autoplay":"","loop":"","src":_vm.videos.VideoResult}})]),_vm._v(" "),_c('a',{staticClass:"slide-media",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showItem(_vm.videos.VideoDigital)}}},[_c('video',{attrs:{"height":"100%","autoplay":"","loop":"","src":_vm.videos.VideoDigital}})])]):_vm._e(),_vm._v(" "),(_vm.current == 2)?_c('div',{key:"2",staticClass:"slide-item"},[_c('a',{staticClass:"slide-media",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showItem(_vm.videos.VideoMoreResult)}}},[_c('video',{attrs:{"height":"100%","autoplay":"","loop":"","src":_vm.videos.VideoMoreResult}})]),_vm._v(" "),_c('a',{staticClass:"slide-media",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showItem(_vm.videos.VideoProgress)}}},[_c('video',{attrs:{"height":"100%","autoplay":"","loop":"","src":_vm.videos.VideoProgress}})])]):_vm._e()])],1),_vm._v(" "),_c('a',{staticClass:"nav-arrow nav-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.nextItem()}}},[_c('icon',{attrs:{"name":"arrow-right","half":""}})],1),_vm._v(" "),_c('div',{staticClass:"nav-lines"},[_c('a',{staticClass:"line",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.setItem(1)}}},[_c('div',{staticClass:"block",class:{ active: _vm.current == 1}})]),_vm._v(" "),_c('a',{staticClass:"line",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.setItem(2)}}},[_c('div',{staticClass:"block",class:{ active: _vm.current == 2}})])])]),_vm._v(" "),_c('modal-media',{attrs:{"src":_vm.modalVideo},on:{"close":_vm.closeModal}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"subtitle"},[_vm._v("Através de resultados concisos, totalmente baseados em porcentagens, os resultados do TD Score servem como um guia para pautar novas estratégias necessárias para as mudanças de sua empresa. "),_c('br'),_vm._v(" Além da maturidade digital total, ele ainda oferece indicadores individuais e minuciosos para cada uma das dimensões compreendidas.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M6BB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8556c5ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("uAKa");
function injectStyle (ssrContext) {
  __webpack_require__("+m3M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8556c5ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MICb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg-abstract.73f1d53.jpg";

/***/ }),

/***/ "MUjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("TECNOLOGIA DIGITAL")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("A tecnologia é base para o que chamamos de transformação digital. E, naturalmente, falar em ferramentas digitais leva-nos à outras reflexões importantes como análise de dados, métricas, indicadores, segurança, tecnologias futuras, gestão da informação, entre outros aspectos.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N/0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__ = __webpack_require__("7zPv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d727e816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__ = __webpack_require__("J8yv");
function injectStyle (ssrContext) {
  __webpack_require__("AQpC")
  __webpack_require__("49wM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d727e816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d727e816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N/7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'experiencia_do_cliente',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/experiencia-do-cliente/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  }
});

/***/ }),

/***/ "NAED":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_Opacity__ = __webpack_require__("CEyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_fullPage_css__ = __webpack_require__("yM+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_fullPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_fullPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__("IcnI");


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















/* eslint-disable */
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

window.$scrollTo = function (to, callback) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;

  function move(amount) {
    document.documentElement.scrollTop = amount;
    document.body.parentNode.scrollTop = amount;
    document.body.scrollTop = amount;
  }
  function position() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
  }
  var start = position(),
      change = to - start,
      currentTime = 0,
      increment = 20;
  var animateScroll = function animateScroll() {
    currentTime += increment;
    var val = Math.easeInOutQuad(currentTime, start, change, duration);
    move(val);
    if (currentTime < duration) requestAnimFrame(animateScroll);else if (callback && typeof callback === 'function') callback();
  };
  animateScroll();
};

window.$loadImages = function (imagesArray) {
  for (var i = 0; i < imagesArray.length; i += 1) {
    var newImage = new Image();
    newImage.onload;
    newImage.src = imagesArray[i];
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
};

__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].component('v-slider', __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].component('v-multiselect', __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a);

/* eslint-disable no-new */

var initApp = function initApp(data) {
  var _store = Object(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */])(data);
  new __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */]({
    el: '#app',
    store: _store,
    router: Object(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */])(_store),
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] }
  });
};

var param = /_=([^&]+)/.exec(location.search);

if (!(param && param[1]) && localStorage.userhash) {
  param = [0, localStorage.userhash];
}

if (param && param[1]) {
  localStorage.userhash = param[1];
  var data = atob(param[1]).split('.');
  __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get('/api/user/' + data[0] + '/' + data[1]).then(function (response) {
    return response.json();
  }).then(function (respose) {
    if (respose.success) {
      console.log(respose.data);
      initApp(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        userid: data[0],
        usercode: data[1],
        username: respose.data.name
      }, respose.data.result));
    } else {
      initApp({});
    }
  });
} else {
  initApp({});
}

/***/ }),

/***/ "Pvwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StrategyForm_vue__ = __webpack_require__("svej");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1867a42c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StrategyForm_vue__ = __webpack_require__("fqse");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StrategyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1867a42c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StrategyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QBAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intro',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/cultura-e-lideranca',
      username: this.$store.state.username
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 1);
  }
});

/***/ }),

/***/ "QLd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"EMPREENDEDORISMO DIGITAL","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/teste/experiencia-do-cliente/formulario","next":"/teste/conclusao"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZXl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("Pessoas")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("Quando começamos a falar sobre transformação digital, logo nos vemos discutindo tecnologia, hardware e automatizações. Entretanto, a transformação está focada na experiência que essas tecnologias podem proporcionar ao ser humano. Sabendo disso, é possível concluir que desenvolver inovações por si só, sem levar em consideração o comportamento humano, é um grande tiro no pé. Que tal começar refletindo sobre como as pessoas da sua organização estão relacionadas à tecnologia?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QlKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QrR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center conclution"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"block-column conclution-go"},[_c('div',{staticClass:"conclution-button"},[_c('div',{staticClass:"conclution-square"}),_vm._v(" "),_c('router-link',{staticClass:"title",attrs:{"to":_vm.nextScreen}},[_c('span',[_vm._v("Ver resultado")]),_vm._v(" "),_c('icon',{attrs:{"name":"arrow-line-middle","width":"60px"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-column conclution-description"},[_c('h1',{staticClass:"title"},[_c('span',{staticClass:"active"},[_vm._v("Obrigado")]),_vm._v(" por participar do teste de maturidade digital!")]),_vm._v(" "),_c('h2',{staticClass:"sub-title"},[_vm._v("Esperamos que, a partir daqui, você consiga enxergar melhor como evoluir na jornada rumo à Transformação Digital.")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n        Disponilizamos o resultado do seu teste\n        "),_c('div',{staticClass:"small"},[_vm._v("além de enviá-lo para o e-mail cadastrado.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RkQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerForm_vue__ = __webpack_require__("WZ8f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f70ad1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerForm_vue__ = __webpack_require__("Fdy6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f70ad1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S6yP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conclusion_vue__ = __webpack_require__("WRc7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0308c2a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conclusion_vue__ = __webpack_require__("gmXK");
function injectStyle (ssrContext) {
  __webpack_require__("2ebs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0308c2a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0308c2a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conclusion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SHb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Peoples_vue__ = __webpack_require__("/Dyj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1635066a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Peoples_vue__ = __webpack_require__("QZXl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Peoples_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1635066a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Peoples_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SVQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"Pessoas","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/intro/formulario","next":"/processos"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SXcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cultura_e_lideranca',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/cultura-e-lideranca/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
});

/***/ }),

/***/ "TYNL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-questions"},[(_vm.title)?_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(question,index){return _c('question',{key:question.index,attrs:{"number":index + 1,"title":question.title,"reverse":question.reverse,"value":_vm.form[question.field],"field":question.field},on:{"input":_vm.rangeChange}})}),_vm._v(" "),(_vm.prev || _vm.next)?_c('div',{staticClass:"box-full-footer"},[(_vm.prev)?_c('v-button',{attrs:{"to":_vm.prev,"super-dark":"","arrow-left":""}},[_vm._v("\n      Voltar\n    ")]):_vm._e(),_vm._v(" "),(_vm.next)?_c('v-button',{attrs:{"to":_vm.next,"super-dark":"","arrow":""}},[_vm._v("\n      Avançar\n    ")]):_vm._e()],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UAlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerExperience_vue__ = __webpack_require__("N/7p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c68c478e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerExperience_vue__ = __webpack_require__("ucjT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerExperience_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c68c478e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerExperience_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ujtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("Estratégia")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("Mindset, cultura e processos digitais precisam de um ecossistema que permita sua existência. No entanto, para alcançá-lo, é necessário criar um estratégia que suporte as mudanças e vá de encontro às metas da empresa.")]),_c('p'),_c('p',[_vm._v("Como anda a estratégia digital da sua empresa?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VhQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalEntrepreneurship_vue__ = __webpack_require__("kHTC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a552d6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalEntrepreneurship_vue__ = __webpack_require__("AYiW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalEntrepreneurship_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a552d6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalEntrepreneurship_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W0Jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvalidLink_vue__ = __webpack_require__("6RyT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50c6c4d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvalidLink_vue__ = __webpack_require__("nY9u");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvalidLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50c6c4d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvalidLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W7jM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarProgress_vue__ = __webpack_require__("2P8x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10483404_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarProgress_vue__ = __webpack_require__("WhQ3");
function injectStyle (ssrContext) {
  __webpack_require__("j6CX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10483404"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10483404_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WRc7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'conclution',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/resultado',
      allData: this.$store.getters.data,
      email: this.$store.state.diagnosis.email,
      submitted: this.$store.state.submitted
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('CALCULATE_OVERALL');

    if (this.email && !this.submitted) {
      fbq('track', 'Lead');
      var data = {
        email: this.email,
        result: this.allData
      };
      this.$http.post('/send-diagnosis', data).then(function () {
        _this.$store.commit('SUBMITTED');
      }, function (response) {
        console.log('Error! ' + response);
      });
    }
    // else if (!this.submitted)
    // this.$router.push('/diagnotico')
  }
});

/***/ }),

/***/ "WZ8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("998L");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customer-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'customer_experience',
      questions: [{ field: 'td_cust_understanding', title: 'Entendendo os hábitos de consumo dos clientes, minha empresa redesenhou - ou adaptou - a jornada de compra com foco na experiência do consumidor. ' }, { field: 'td_cust_focus', title: 'A experiência do consumidor é o foco em todos os pontos de contato entre a empresa e seus consumidores.' }, { field: 'td_cust_data', title: 'A empresa coleta resultados e retornos dos seus clientes através de plataformas digitais.' }, { field: 'td_biz_model', title: 'A empresa pensa em investir em novos modelos de negócio ou mesmo adaptar o atual ao digital.' }, { field: 'td_tech_adoption', title: 'A empresa utiliza a tecnologia constantemente para melhoria do seu produto e inovação contínua da sua entrega.' }, { field: 'td_experimentation', title: 'A empresa busca aplicar o Test and Learning - ou seja, testar mudanças, “falhar rápido” e aprender com o que foi testado para otimizar em seguida.' }, { field: 'td_digital_delivery', title: 'A empresa oferece a entrega parcial ou integral de seus produtos / serviços através de plataformas digitais.' }]
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
});

/***/ }),

/***/ "WhQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-progress",style:(_vm.width)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XXpS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XrWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("bQkl");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'experiencia_do_cliente-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'experiencia_do_cliente',
      questions: this.$store.state.questions.experiencia_do_cliente
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  }
});

/***/ }),

/***/ "XsaO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("CULTURA E LIDERANÇA")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":"/teste/cultura-e-lideranca/formulario"}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("Para que a transformação digital aconteça de maneira efetiva é necessário que as pessoas estejam abertas a uma nova forma de pensar, criando uma cultura digital e formando líderes dispostos a encarar os desafios que surgem nesse novo contexto.")]),_vm._v(" "),_c('p',[_vm._v("Vamos começar analisando questões relacionadas ao seu mindset, aspectos de liderança e inovação.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YFvj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Diagnosis__ = __webpack_require__("smTb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Intro__ = __webpack_require__("xa4f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IntroForm__ = __webpack_require__("rtiZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Peoples__ = __webpack_require__("SHb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PeoplesForm__ = __webpack_require__("1tTS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Process__ = __webpack_require__("6WF7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProcessForm__ = __webpack_require__("rXno");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Customer__ = __webpack_require__("d5kq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CustomerForm__ = __webpack_require__("RkQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Strategy__ = __webpack_require__("uHss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_StrategyForm__ = __webpack_require__("Pvwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Conclusion__ = __webpack_require__("S6yP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Result__ = __webpack_require__("N/0d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_test_Intro__ = __webpack_require__("gpHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_test_CultureAndLeadership__ = __webpack_require__("b0Ct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_test_CultureAndLeadershipForm__ = __webpack_require__("gMzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_test_OperationalAgility__ = __webpack_require__("kNNL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_test_OperationalAgilityForm__ = __webpack_require__("kM6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_test_DigitalTechnology__ = __webpack_require__("boDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_test_DigitalTechnologyForm__ = __webpack_require__("f2Fm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_test_CustomerExperience__ = __webpack_require__("UAlu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_test_CustomerExperienceForm__ = __webpack_require__("20xW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_test_DigitalEntrepreneurship__ = __webpack_require__("VhQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_test_DigitalEntrepreneurshipForm__ = __webpack_require__("GK9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_test_Conclusion__ = __webpack_require__("qJD+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_test_Result__ = __webpack_require__("sOkK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_test_InvalidLink__ = __webpack_require__("W0Jg");

































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/diagnotico',
    name: 'Diagnótico',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Diagnosis__["a" /* default */]
  }, {
    path: '/intro',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Intro__["a" /* default */]
  }, {
    path: '/intro/formulario',
    component: __WEBPACK_IMPORTED_MODULE_5__components_IntroForm__["a" /* default */]
  }, {
    path: '/pessoas',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Peoples__["a" /* default */]
  }, {
    path: '/pessoas/formulario',
    component: __WEBPACK_IMPORTED_MODULE_7__components_PeoplesForm__["a" /* default */]
  }, {
    path: '/processos',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Process__["a" /* default */]
  }, {
    path: '/processos/formulario',
    component: __WEBPACK_IMPORTED_MODULE_9__components_ProcessForm__["a" /* default */]
  }, {
    path: '/cliente',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Customer__["a" /* default */]
  }, {
    path: '/cliente/formulario',
    component: __WEBPACK_IMPORTED_MODULE_11__components_CustomerForm__["a" /* default */]
  }, {
    path: '/estrategia',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Strategy__["a" /* default */]
  }, {
    path: '/estrategia/formulario',
    component: __WEBPACK_IMPORTED_MODULE_13__components_StrategyForm__["a" /* default */]
  }, {
    path: '/conclusao',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Conclusion__["a" /* default */]
  }, {
    path: '/resultado',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Result__["a" /* default */]
  }, {
    path: '/teste',
    component: __WEBPACK_IMPORTED_MODULE_16__components_test_Intro__["a" /* default */]
  }, {
    path: '/teste/cultura-e-lideranca',
    component: __WEBPACK_IMPORTED_MODULE_17__components_test_CultureAndLeadership__["a" /* default */]
  }, {
    path: '/teste/cultura-e-lideranca/formulario',
    component: __WEBPACK_IMPORTED_MODULE_18__components_test_CultureAndLeadershipForm__["a" /* default */]
  }, {
    path: '/teste/agilidade-operacional',
    component: __WEBPACK_IMPORTED_MODULE_19__components_test_OperationalAgility__["a" /* default */]
  }, {
    path: '/teste/agilidade-operacional/formulario',
    component: __WEBPACK_IMPORTED_MODULE_20__components_test_OperationalAgilityForm__["a" /* default */]
  }, {
    path: '/teste/tecnologia-digital',
    component: __WEBPACK_IMPORTED_MODULE_21__components_test_DigitalTechnology__["a" /* default */]
  }, {
    path: '/teste/tecnologia-digital/formulario',
    component: __WEBPACK_IMPORTED_MODULE_22__components_test_DigitalTechnologyForm__["a" /* default */]
  }, {
    path: '/teste/experiencia-do-cliente',
    component: __WEBPACK_IMPORTED_MODULE_23__components_test_CustomerExperience__["a" /* default */]
  }, {
    path: '/teste/experiencia-do-cliente/formulario',
    component: __WEBPACK_IMPORTED_MODULE_24__components_test_CustomerExperienceForm__["a" /* default */]
  }, {
    path: '/teste/empreendedorismo-digital',
    component: __WEBPACK_IMPORTED_MODULE_25__components_test_DigitalEntrepreneurship__["a" /* default */]
  }, {
    path: '/teste/empreendedorismo-digital/formulario',
    component: __WEBPACK_IMPORTED_MODULE_26__components_test_DigitalEntrepreneurshipForm__["a" /* default */]
  }, {
    path: '/teste/conclusao',
    component: __WEBPACK_IMPORTED_MODULE_27__components_test_Conclusion__["a" /* default */]
  }, {
    path: '/teste/resultado',
    component: __WEBPACK_IMPORTED_MODULE_28__components_test_Result__["a" /* default */]
  }, {
    path: '/teste/link-invalido',
    component: __WEBPACK_IMPORTED_MODULE_29__components_test_InvalidLink__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to) {
    if (to.hash) return { selector: to.hash };

    return false;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (store) {

  router.beforeEach(function (to, from, next) {
    if (to.path != '/teste/link-invalido' && /^\/teste/g.test(to.path) && !store.state.userid) return next('/teste/link-invalido');

    next();
  });

  return router;
});

/***/ }),

/***/ "Yib5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"request-error",class:{ active: _vm.current }},[_vm._v("\n  "+_vm._s(_vm.error ? 'Erro ao reenviar.' : 'Não foi possível salvar suas informações.')+"\n  "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.error),expression:"!error"}],staticClass:"btn-action",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resend($event)}}},[_vm._v("\n    "+_vm._s(!_vm.resubmitting ? 'Reenviar' : (!_vm.error ? 'Enviando...' : ''))+"\n  ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"btn-action",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.sendemail($event)}}},[_vm._v("\n    Enviar resultado por email\n  ")]),_vm._v(" "),_c('a',{staticClass:"btn-close",attrs:{"href":""}},[_vm._v("x")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZPg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"AGLIDADE OPERACIONAL","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/teste/cultura-e-lideranca/formulario","next":"/teste/tecnologia-digital"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a67d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("Processos")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("Passar pela Transformação Digital signifca ter todos os setores da empresa alinhados e colaborando entre si. Para operações digitais serem bem-sucedida, é preciso que a organização opere em conjunto, com metas bem definidas e o digital no foco.")]),_vm._v(" "),_c('p',[_vm._v("Agora, vamos ver se a sua empresa está seguindo este caminho?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aV2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[(!_vm.back)?_c('div',{staticClass:"header-nav"},[_c('a',{staticClass:"link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('como-funciona')}}},[_vm._v("Como funciona?")])]):_c('div',{staticClass:"header-nav"},[_c('a',{staticClass:"link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$router.go(-1)}}},[_vm._v("Back")])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b0Ct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CultureAndLeadership_vue__ = __webpack_require__("SXcv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7e8728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CultureAndLeadership_vue__ = __webpack_require__("XsaO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CultureAndLeadership_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7e8728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CultureAndLeadership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b66r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"slide-vertical"},[_c('nav',{staticClass:"slide-nav"},[_c('ul',[_c('li',[_c('a',{class:{ active: _vm.isSlide('people') },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();},"mouseover":function($event){_vm.changeVertical('people')}}},[_vm._v("Pessoas")])]),_vm._v(" "),_c('li',[_c('a',{class:{ active: _vm.isSlide('process') },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();},"mouseover":function($event){_vm.changeVertical('process')}}},[_vm._v("Processos")])]),_vm._v(" "),_c('li',[_c('a',{class:{ active: _vm.isSlide('experience') },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();},"mouseover":function($event){_vm.changeVertical('experience')}}},[_vm._v("Cliente")])]),_vm._v(" "),_c('li',[_c('a',{class:{ active: _vm.isSlide('strategy') },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();},"mouseover":function($event){_vm.changeVertical('strategy')}}},[_vm._v("Estratégia")])])])]),_vm._v(" "),_c('div',{staticClass:"slide-area"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.slideVertical == 'people')?_c('div',{key:"1",staticClass:"slide-item people"},[_c('div',{staticClass:"description"},[_vm._v("\n          A Transformação Digital é sobre pessoas, não tecnologia. Qualquer evolução organizacional é pautada na liderança exercida pelos colaboradores em um ambiente propício, assegurado por uma cultura construída ao redor do digital.\n        ")])]):_vm._e(),_vm._v(" "),(_vm.slideVertical == 'process')?_c('div',{key:"2",staticClass:"slide-item process"},[_c('div',{staticClass:"description"},[_vm._v("\n          A jornada pela Transformação Digital é traçada com base em processos que se beneficiam das expertises de todos os setores trabalhando em conjunto. Metas só são atingidas quando a organização opera de forma colaborativa e compartilhada.\n        ")])]):_vm._e(),_vm._v(" "),(_vm.slideVertical == 'experience')?_c('div',{key:"3",staticClass:"slide-item experience"},[_c('div',{staticClass:"description"},[_vm._v("\n          O mercado deixou de ditar as regras. Agora, os consumidores criam demandas para serem supridas pelas empresas - que, por sua vez, trabalham para garantir experiências novas e únicas, fechando assim o ciclo da Transformação Digital.\n        ")])]):_vm._e(),_vm._v(" "),(_vm.slideVertical == 'strategy')?_c('div',{key:"4",staticClass:"slide-item strategy"},[_c('div',{staticClass:"description"},[_vm._v("\n          Para se adaptar à Transformação Digital é necessário desenvolver estratégias que sejam compatíveis às mudanças constantes, suportadas por um ecossistema de cultura, mindset e processos digitais alinhados aos mesmos objetivos.\n        ")])]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bQkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questions_vue__ = __webpack_require__("8FPx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e40525a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questions_vue__ = __webpack_require__("TYNL");
function injectStyle (ssrContext) {
  __webpack_require__("QlKR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e40525a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e40525a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "boDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalTechnology_vue__ = __webpack_require__("sBMc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31575afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalTechnology_vue__ = __webpack_require__("MUjN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalTechnology_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31575afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalTechnology_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bxX7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cf9X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/abstract-float.9974df5.png";

/***/ }),

/***/ "d5Sz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__("eE7u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a00326_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__("hSh1");
function injectStyle (ssrContext) {
  __webpack_require__("KCbc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39a00326"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a00326_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d5kq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__("nIg1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c10587_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__("KeHJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c10587_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d5wn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dwPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("bQkl");
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'agilidade_operacional-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'agilidade_operacional',
      questions: this.$store.state.questions.agilidade_operacional
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
});

/***/ }),

/***/ "e7Pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function resultQuestions(formQuestions, formAnswers) {
  var sumPoints = 0;
  var total = 0;
  for (var i = 0; i < formQuestions.length; i += 1) {
    var question = formQuestions[i];
    var key = question.field;
    sumPoints += formAnswers[key] * question.weight;
    total += 100 * question.weight;
  }
  return Math.floor(sumPoints / total * 100);
}

var questionsVuex = {
  data: function data() {
    return {
      confirmEmail: this.$store.state.diagnosis.email,
      form: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$store.state[this.keyForm]),
      userid: this.$store.state.userid,
      usercode: this.$store.state.usercode,
      questions: this.$store.state.questions[this.keyForm]
    };
  },

  methods: {
    rangeChange: function rangeChange(newValue, id) {
      this.form[id] = newValue;
      this.$store.commit('UPDATE_FIELD', {
        form: this.keyForm,
        key: id,
        value: newValue
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('UPDATE_FIELD', {
      form: 'test_results',
      key: '' + this.keyForm,
      value: resultQuestions(this.questions, this.form)
    });

    var data = {
      cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
      experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
      empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
      tecnologia_digital: this.$store.state.tecnologia_digital,
      agilidade_operacional: this.$store.state.agilidade_operacional,
      test_results: this.$store.state.test_results
    };

    try {
      this.$http.post('/api/user/' + this.userid + '/' + this.usercode, data);
    } catch (e) {}
  }
};

/* harmony default export */ __webpack_exports__["a"] = (questionsVuex);

/***/ }),

/***/ "eE7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'question',
  props: {
    number: Number,
    field: String,
    reverse: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    title: String
  },
  data: function data() {
    var value = this.value;
    if (this.reverse) {
      value = 100 - value;
    }
    return {
      input: value,
      answer: 'N/A',
      answerClass: 'grey-dark'
    };
  },
  mounted: function mounted() {
    var value = this.value;
    if (this.reverse) {
      value = 100 - value;
    }
    if (this.value > 0) this.isApplicable(true);
  },

  methods: {
    changeInput: function changeInput(value) {
      if (this.reverse) {
        this.$emit('input', 100 - value, this.field);
      } else {
        this.$emit('input', value, this.field);
      }

      value > 0 ? this.isApplicable(true) : this.isApplicable(false);
      switch (true) {
        case value === 0:
          this.answer = 'N/A';
          this.answerClass = 'grey-dark';
          break;
        case value <= 25:
          this.answer = 'Discordo totalmente';
          this.answerClass = 'grey';
          break;
        case value <= 50:
          this.answer = 'Discordo em partes';
          this.answerClass = 'grey';
          break;
        case value <= 75:
          this.answer = 'Concordo em partes';
          this.answerClass = 'green';
          break;
        case value <= 100:
          this.answer = 'Concordo totalmente';
          this.answerClass = 'green';
          break;
        default:
          this.answer = 'N/A';
          this.answerClass = 'grey-dark';
      }
    },
    applicableClick: function applicableClick(event) {
      event.currentTarget.classList.contains('active') ? this.isApplicable(false) : this.isApplicable(true);
    },
    isApplicable: function isApplicable(boolean) {
      var el = this.$el.querySelector('.applicable');
      var text = el.querySelector('.text');
      if (boolean) {
        el.classList.add('active');
        text.innerHTML = 'Aplicável';
        if (this.input === 0) this.input = 1;
      } else {
        el.classList.remove('active');
        text.innerHTML = 'Não aplicável';
        this.input = 0;
      }
    }
  }
});

/***/ }),

/***/ "f2Fm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalTechnologyForm_vue__ = __webpack_require__("4aXq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2853f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalTechnologyForm_vue__ = __webpack_require__("swjp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalTechnologyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2853f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalTechnologyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fP26":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * fullPage Pure Javascript v.0.0.9 (Alpha) - Not support given until Beta version.
 * https://github.com/alvarotrigo/fullPage.js
 * MIT licensed
 *
 * Copyright (C) 2013 alvarotrigo.com - A project by Alvaro Trigo
 */
(function(n,m,C,v,e){ true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){n.fullpage=v(m,C);return n.fullpage}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports?module.exports=v(m,C):m.fullpage=v(m,C)})(this,window,document,function(n,m,C){function v(a,b){for(var d in b)b.hasOwnProperty(d)&&null!==d&&(a.style[d]=b[d]);return a}function e(a,b){b=b||m;return b.querySelector(a)}function p(a,b){b=b||m;return b.querySelectorAll(a)}function q(a){for(var b=0;a=a.previousSibling;)3==a.nodeType&&/^\s*$/.test(a.data)||b++;return b}
function ua(a,b){a.style.display="undefined"!==typeof b?b?"block":"none":"block"==a.style.display?"none":"block";return a}function w(a,b){return!!a.className.match(new RegExp("(\\s|^)"+b+"(\\s|$)"))}function B(a,b){a&&w(a,b)&&(a.className=a.className.replace(new RegExp("(\\s|^)"+b+"(\\s|$)"),""))}function t(a,b){a&&!w(a,b)&&(a.className+=" "+b)}function I(a,b){return a&&(b(a)?a:I(a.parentNode,b))}function R(){return"innerHeight"in n?n.innerHeight:m.documentElement.offsetHeight}function J(a){a.preventDefault?
a.preventDefault():a.returnValue=!1}function z(a){var b={};return a&&"[object Function]"===b.toString.call(a)}function K(a,b,d){b=b.split(" ");for(var c=0,e=b.length;c<e;c++)m.addEventListener?a.addEventListener(b[c],d,!1):a.attachEvent(b[c],d,!1)}function ea(a,b,d,c){var f=Sa(a),e=b-f,h=0;S=!0;var k=function(){if(S){var b;h+=20;b=Math.easeInOutCubic(h,f,e,d);va(a,b);h<d?setTimeout(k,20):"undefined"!==typeof c&&c()}else h<d&&c()};k()}function fa(){var a=m.documentElement;return(n.pageYOffset||a.scrollTop)-
(a.clientTop||0)}function wa(a){for(a=a.nextSibling;a&&1!=a.nodeType;)a=a.nextSibling;return a}function xa(a){for(a=a.previousSibling;a&&1!=a.nodeType;)a=a.previousSibling;return a}function Sa(a){return a.self!=n&&w(a,"fp-slides")?a.scrollLeft:!c.autoScrolling||c.scrollBar?fa():a.offsetTop}function va(a,b){!c.autoScrolling||c.scrollBar||a.self!=n&&w(a,"fp-slides")?a.self!=n&&w(a,"fp-slides")?a.scrollLeft=b:a.scrollTo(0,b):a.style.top=b+"px"}function ya(a,b){T("autoScrolling",a,b);var d=e(".fp-section.active");
c.autoScrolling&&!c.scrollBar?(v(m.body,{overflow:"hidden",height:"100%"}),v(m.getElementsByTagName("html")[0],{overflow:"hidden",height:"100%"}),ga(c.recordHistory,"internal"),v(r,{"-ms-touch-action":"none","touch-action":"none"}),d&&L(d.offsetTop)):(v(m.body,{overflow:"visible",height:"100%"}),v(m.getElementsByTagName("html")[0],{overflow:"visible",height:"100%"}),ga(!1,"internal"),v(r,{"-ms-touch-action":"","touch-action":""}),L(0),d=U(d.offsetTop),d.element.scrollTo(0,d.options))}function ga(a,
b){T("recordHistory",a,b)}function M(a,b){T("scrollingSpeed",a,b)}function V(){var a=xa(e(".fp-section.active"));a&&A(a,null,!0)}function ha(){var a=wa(e(".fp-section.active"));a&&A(a,null,!1)}function W(a,b){var d=za(a);"undefined"!==typeof b?ia(a,b):d&&A(d)}function X(){Aa("next")}function Y(){Aa("prev")}function Ba(a){if(!w(r,"fp-destroyed")){u=!0;Ca=R();for(var b=p(".fp-section"),d=0;d<b.length;++d){var f=b[d],l=e(".fp-slides",f),f=p(".fp-slide",f);l&&1<f.length&&N(l,e(".fp-slide.active",l))}b=
e(".fp-section.active");q(b)&&L(b.offsetTop);u=!1;z(c.afterResize)&&a&&c.afterResize.call(r);z(c.afterReBuild)&&!a&&c.afterReBuild.call(r)}}function Ta(){var a=m.createElement("div");a.setAttribute("id","fp-nav");var b=m.createElement("ul");a.appendChild(b);m.body.appendChild(a);x=e("#fp-nav");x.style.color=c.navigationColor;t(x,c.navigationPosition);c.showActiveTooltip&&t(x,"fp-show-active");a="";for(b=0;b<p(".fp-section").length;b++){var d="";c.anchors.length&&(d=c.anchors[b]);a=a+'<li><a href="#'+
d+'"><span></span></a>';d=c.navigationTooltips[b];typeof d!==C&&""!==d&&(a+='<div class="fp-tooltip '+c.navigationPosition+'">'+d+"</div>");a+="</li>"}b=e("ul",x);b.innerHTML+=a;a=p(".fp-slidesNav a");for(b=0;b<a.length;b++)K(a[b],"click onclick touchstart",function(a){a=n.event||a||a.originalEvent;J(a);a=q(this.parentNode);A(p(".fp-section")[a],null,!1)})}function Ua(){var a;if(!c.autoScrolling||c.scrollBar){for(var b=fa(),d=0,f=Math.abs(b-p(".fp-section")[0].offsetTop),l=p(".fp-section"),g=0;g<
l.length;++g){var h=Math.abs(b-l[g].offsetTop);h<f&&(d=g,f=h)}a=p(".fp-section")[d]}if(!c.autoScrolling||c.scrollBar){if(!w(a,"active")){ja=!0;b=e(".fp-section.active");d=q(b)+1;f=Da(a);l=a.getAttribute("data-anchor");g=q(a)+1;if(h=e(".fp-slide.active",a))var k=h.getAttribute("data-anchor"),m=q(h);E&&(B(b,"active"),t(a,"active"),z(c.onLeave)&&c.onLeave.call(b,d,g,f),z(c.afterLoad)&&c.afterLoad.call(a,l,g),Z(l,0),c.anchors.length&&(F=l,ka(m,k,l,g)));clearTimeout(Ea);Ea=setTimeout(function(){ja=!1},
100)}c.fitToSection&&(clearTimeout(Fa),Fa=setTimeout(function(){if(E&&!c.autoScrolling||c.scrollBar)q(e(".fp-section.active"))==q(a)&&(u=!0),A(a),u=!1},c.fitToSectionDelay))}}function aa(a){"down"==a?ha():V()}function la(a){var b=n.event||a||a.originalEvent;ma(b)&&(c.autoScrolling&&J(a),a=e(".fp-section.active"),a=p(".fp-slides",a),E&&!G&&(b=Ga(b),O=b.y,ba=b.x,a&&Math.abs(ca-ba)>Math.abs(P-O)?Math.abs(ca-ba)>("innerWidth"in n?n.innerWidth:m.documentElement.offsetWidth)/100*c.touchSensitivity&&(ca>
ba?X():Y()):c.autoScrolling&&Math.abs(P-O)>R()/100*c.touchSensitivity&&(P>O?aa("down"):O>P&&aa("up"))))}function ma(a){return"undefined"===typeof a.pointerType||"mouse"!=a.pointerType}function na(a){a=n.event||a||a.originalEvent;c.fitToSection&&(S=!1);ma(a)&&(a=Ga(a),P=a.y,ca=a.x)}function Ha(a,b){for(var d=0,c=a.slice(Math.max(a.length-b,1)),e=0;e<c.length;e++)d+=c[e];return Math.ceil(d/b)}function Va(a){var b=(new Date).getTime();if(c.autoScrolling){a=n.event||a||a.originalEvent;var d=a.wheelDelta||
-a.deltaY||-a.detail,f=Math.max(-1,Math.min(1,d));149<H.length&&H.shift();H.push(Math.abs(d));c.scrollBar&&J(a);a=b-Ia;Ia=b;200<a&&(H=[]);E&&(b=Ha(H,10),a=Ha(H,70),b>=a&&(0>f?aa("down"):aa("up")));return!1}c.fitToSection&&(S=!1)}function Aa(a){var b=e(".fp-section.active");if((b=e(".fp-slides",b))&&!G){var d=e(".fp-slide.active",b),f;f="prev"===a?xa(d):wa(d);if(!f){if(!c.loopHorizontal)return;f=d.parentNode.firstChild;for(var l=[];f;f=f.nextSibling)1==f.nodeType&&f!=d&&l.push(f);f="prev"===a?l[l.length-
1]:l[0]}G=!0;N(b,f)}}function A(a,b,d){if(null!==a&&(b={element:a,callback:b,isMovementUp:d,dtop:a.offsetTop,yMovement:Da(a),anchorLink:a.getAttribute("data-anchor"),sectionIndex:q(a),activeSlide:e(".fp-slide.active",a),activeSection:e(".fp-section.active"),leavingSection:q(e(".fp-section.active"))+1,localIsResizing:u},!(q(b.activeSection)==b.sectionIndex&&!u||c.scrollBar&&fa()===b.dtop))){if(b.activeSlide)var f=b.activeSlide.getAttribute("data-anchor"),l=q(b.activeSlide);d=p(".fp-section");for(var g=
0;g<d.length;g++)B(d[g],"active");t(a,"active");E=!1;ka(l,f,b.anchorLink,b.sectionIndex);z(c.onLeave)&&!b.localIsResizing&&c.onLeave.call(b.activeSection,b.leavingSection,b.sectionIndex+1,b.yMovement);Wa(b);F=b.anchorLink;Z(b.anchorLink,b.sectionIndex)}}function Wa(a){if(c.css3&&c.autoScrolling&&!c.scrollBar)Ja("translate3d(0px, -"+a.dtop+"px, 0px)",!0),c.scrollingSpeed?setTimeout(function(){oa(a)},c.scrollingSpeed):oa(a);else{var b=U(a.dtop);ea(b.element,b.options,c.scrollingSpeed,function(){oa(a)})}}
function U(a){var b={};c.autoScrolling&&!c.scrollBar?(b.options=-a,b.element=e(".fullpage-wrapper")):(b.options=a,b.element=n);return b}function oa(a){z(c.afterLoad)&&!a.localIsResizing&&c.afterLoad.call(a.element,a.anchorLink,a.sectionIndex+1);E=!0;z(a.callback)&&a.callback.call(this)}function Xa(){var a=n.location.hash.replace("#","").split("/"),b=a[0],a=a[1];b&&ia(b,a)}function Ya(a){var b=this;b.self==n&&(b=a.target||a.srcElement);w(b,"fp-prev")?Y():X()}function Ka(){if(!ja){var a=n.location.hash.replace("#",
"").split("/"),b=a[0],a=a[1];if(b.length){var d="undefined"===typeof F,c="undefined"===typeof F&&"undefined"===typeof a&&!G;(b&&b!==F&&!d||c||!G&&pa!=a)&&ia(b,a)}}}function N(a,b){var d=q(b),f=I(a,function(a){return w(a,"fp-section")}),l=q(f),g=f.getAttribute("data-anchor"),h=e(".fp-slidesNav",f),k=La(b),m=u;if(c.onSlideLeave){var n=e(".fp-slide.active",f),r=q(n),v;v=r==d?"none":r>d?"left":"right";m||"none"===v||z(c.onSlideLeave)&&c.onSlideLeave.call(n,g,l+1,r,v,d)}n=p(".fp-slide",f);for(r=0;r<n.length;r++)B(n[r],
"active");t(b,"active");!c.loopHorizontal&&c.controlArrows&&(ua(e(".fp-controlArrow.fp-prev",f),0!==d),ua(e(".fp-controlArrow.fp-next",f),!b.is(":last-child")));w(f,"active")&&ka(d,k,g,l);var x=function(){m||z(c.afterSlideLoad)&&c.afterSlideLoad.call(b,g,l+1,k,d);G=!1};c.css3?(f="translate3d(-"+Math.round(b.offsetLeft)+"px, 0px, 0px)",n=e(".fp-slidesContainer",a),Ma(n,0<c.scrollingSpeed),Na(n,f),setTimeout(function(){x()},c.scrollingSpeed,c.easing)):ea(a,Math.round(b.offsetLeft),c.scrollingSpeed,
function(){x()});c.slidesNavigation&&(B(e(".active",h),"active"),h=p("li",h)[d],h=e("a",h),t(h,"active"))}function Za(){if(qa){if("text"!==m.activeElement.getAttribute("type")){var a=R();Math.abs(a-ra)>20*Math.max(ra,a)/100&&(Ba(!0),ra=a)}}else clearTimeout(Oa),Oa=setTimeout(function(){Ba(!0)},350)}function Ma(a){var b="all "+c.scrollingSpeed+"ms "+c.easingcss3;B(a,"fp-notransition");v(a,{"-webkit-transition":b,transition:b});return a}function Z(a,b){if(c.menu){var d=e(c.menu);d&&(B(e(".active",d),
"active"),t(e('[data-menuanchor="'+a+'"]',d),"active"))}c.navigation&&(B(e(".active",x),"active"),a?t(e('a[href="#'+a+'"]',x),"active"):(d=p("li",x)[b],t(e("a",d),"active")))}function Da(a){var b=q(e(".fp-section.active"));a=q(a);return b==a?"none":b>a?"up":"down"}function Ja(a,b){b?Ma(r):t(r,"fp-notransition");Na(r,a);setTimeout(function(){B(r,"fp-notransition")},10)}function za(a){var b=e('.fp-section[data-anchor="'+a+'"]');b||(b=p(".fp-section")[a-1]);return b}function ia(a,b){var d=za(decodeURI(a));
"undefined"===typeof b&&(b=0);a===F||w(d,"active")?Pa(d,b):A(d,function(){Pa(d,b)})}function Pa(a,b){if("undefined"!==typeof b){var d=e(".fp-slides",a),c;c=e(".fp-slides",a);var l=e('.fp-slide[data-anchor="'+b+'"]',c);c&&!l&&(l=p(".fp-slide",c)[b]);(c=l)&&N(d,c)}}function ka(a,b,d,f){f="";c.anchors.length&&(a?("undefined"!==typeof d&&(f=d),"undefined"===typeof b&&(b=a),pa=b,Qa(f+"/"+b)):("undefined"!==typeof a&&(pa=b),Qa(d)));sa()}function Qa(a){if(c.recordHistory)location.hash=a;else if(qa||ta)history.replaceState(C,
C,"#"+a);else{var b=n.location.href.split("#")[0];n.location.replace(b+"#"+a)}}function La(a){var b=a.getAttribute("data-anchor");a=q(a);b||(b=a);return b}function sa(a){a=e(".fp-section.active");var b=e(".fp-slide.active",a),d=a.getAttribute("data-anchor");a=q(a);a=String(a);c.anchors.length&&(a=d);b&&(b=La(b),a=a+"-"+b);a=a.replace("/","-").replace("#","");m.body.className=m.body.className.replace(RegExp("\\b\\s?fp-viewing-[^\\s]+\\b","g"),"");t(m.body,"fp-viewing-"+a)}function da(a,b,c,f,e){a.addEventListener?
(a.addEventListener(c,b,!1),"undefined"!==typeof e&&a.addEventListener(e,b,!1)):a.attachEvent(f,b)}function Ga(a){var b=[];b.y="undefined"!==typeof a.pageY&&(a.pageY||a.pageX)?a.pageY:a.touches[0].pageY;b.x="undefined"!==typeof a.pageX&&(a.pageY||a.pageX)?a.pageX:a.touches[0].pageX;ta&&ma(a)&&(b.y=a.touches[0].pageY,b.x=a.touches[0].pageX);return b}function $a(a,b){M(0,"internal");"undefined"!==typeof b&&(u=!0);var c=I(a,function(a){return w(a,"fp-slides")});N(c,a);"undefined"!==typeof b&&(u=!1);
M(Q.scrollingSpeed,"internal")}function L(a){c.scrollBar?(a=U(a),va(a.element,a.options,0)):c.css3?Ja("translate3d(0px, -"+a+"px, 0px)",!1):r.style.top=-a+"px"}function Na(a,b){v(a,{"-webkit-transform":b,"-moz-transform":b,"-ms-transform":b,transform:b})}function T(a,b,d){c[a]=b;"internal"!==d&&(Q[a]=b)}var c,G=!1,qa=navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/),ta="ontouchstart"in n||0<navigator.msMaxTouchPoints||
navigator.maxTouchPoints,Ca=R(),u=!1,F,pa,E=!0,H=[],x,S,Q,r;Math.easeInOutCubic=function(a,b,c,e){return 1>(a/=e/2)?c/2*a*a*a+b:c/2*((a-=2)*a*a+2)+b};var Ea,Fa,ja=!1,P=0,ca=0,O=0,ba=0,Ia=(new Date).getTime();m.addEventListener?n.addEventListener("hashchange",Ka,!1):n.attachEvent("onhashchange",Ka);var Ra;m.onkeydown=function(a){clearTimeout(Ra);var b=m.activeElement.tagName;if("SELECT"!==b&&"INPUT"!==b&&c.keyboardScrolling&&c.autoScrolling){a=n.event||a||a.originalEvent;for(var d=a.charCode||a.keyCode,
b=[40,38,32,33,34],e=0;e<b.length;e++)b[e]==d&&J(a);var l=a.shiftKey;Ra=setTimeout(function(){switch(d){case 38:case 33:V();break;case 32:if(l){V();break}case 40:case 34:ha();break;case 36:W(1);break;case 35:W(p(".fp-section").length);break;case 37:Y();break;case 39:X()}},150)}};null!==e(".fp-slidesNav a")&&K(e(".fp-slidesNav a"),"click onclick touchstart",function(a){J(a);a=I(this,function(a){return w(e1,"fp-section")});a=e(".fp-slides",a);var b=I(this,function(a){return"li"===a.tagName}),b=q(b),
b=p(".fp-slide",a)[b];N(a,b)});var ra=Ca,Oa;return{initialize:function(a,b){var d={menu:!1,anchors:[],navigation:!1,navigationPosition:"right",navigationColor:"#000",navigationTooltips:[],showActiveTooltip:!1,slidesNavigation:!1,slidesNavPosition:"bottom",scrollBar:!1,css3:!0,scrollingSpeed:700,autoScrolling:!0,fitToSection:!0,fitToSectionDelay:1E3,easingcss3:"ease",loopHorizontal:!0,touchSensitivity:5,keyboardScrolling:!0,recordHistory:!0,controlArrows:!0,sectionSelector:".section",slideSelector:".slide",
afterLoad:null,onLeave:null,afterRender:null,afterResize:null,afterReBuild:null,afterSlideLoad:null,onSlideLeave:null},f=b;"object"!==typeof f&&(f={});for(var l in f)d.hasOwnProperty(l)&&(d[l]=f[l]);c=d;d=c;if(null===d||"object"!==typeof d)Q=d;else{var f=d.constructor(),g;for(g in d)d.hasOwnProperty(g)&&(f[g]=d[g]);Q=f}r=e(a);B(r,"fp-destroyed");for(g=0;g<c.anchors.length;g++)d=c.anchors[g],(m.getElementById("#"+d)||p('[name="'+d+'"]').length)&&console&&console.error&&console.error("fullPage: data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE).");
if(c.css3){g=c;var d=m.createElement("p"),h,f={webkitTransform:"-webkit-transform",OTransform:"-o-transform",msTransform:"-ms-transform",MozTransform:"-moz-transform",transform:"transform"};m.body.insertBefore(d,null);for(var k in f)d.style[k]!==C&&(d.style[k]="translate3d(1px,1px,1px)",h=n.getComputedStyle(d).getPropertyValue(f[k]));m.body.removeChild(d);g.css3=h!==C&&0<h.length&&"none"!==h}null!==r?(v(r,{height:"100%",position:"relative"}),t(r,"fullpage-wrapper"),t(e("html"),"fp-enabled")):console&&
console.error&&console.error("fullPage: Error! Fullpage.js needs to be initialized with a selector. For example: fullpage('#fullpage');");da(e(".fullpage-wrapper"),Va,"mousewheel","onmousewheel","wheel");if(qa||ta)h=e(".fullpage-wrapper"),m.addEventListener&&(k=n.PointerEvent?{down:"pointerdown",move:"pointermove"}:{down:"MSPointerDown",move:"MSPointerMove"},h.removeEventListener("touchstart",na),h.removeEventListener(k.down,na),h.removeEventListener("touchmove",la),h.removeEventListener(k.move,la),
K(h,"touchstart "+k.down,na),K(h,"touchmove "+k.move,la));da(n,Za,"resize","onresize");da(n,Ua,"scroll","onscroll","onscroll");k=p(c.sectionSelector);for(h=0;h<k.length;++h)t(k[h],"fp-section");k=p(c.slideSelector);for(h=0;h<k.length;++h)t(k[h],"fp-slide");c.navigation&&Ta();k=p(".fp-section");for(h=0;h<k.length;h++)if(f=h,g=k[h],d=p(".fp-slide",g),l=d.length,f||null!==e(".fp-section.active")||t(g,"active"),"undefined"!==typeof c.anchors[f]&&(g.setAttribute("data-anchor",c.anchors[f]),w(g,"active")&&
Z(c.anchors[f],f)),0<l){var y=100*l,f=100/l;g.innerHTML='<div class="fp-slides"><div class="fp-slidesContainer">'+g.innerHTML+"</div></div>";d=p(".fp-slide",g);e(".fp-slidesContainer",g).style.width=y+"%";if(c.controlArrows&&1<l){var y=g,u=m.createElement("div");u.className="fp-controlArrow fp-prev";var D=m.createElement("div");D.className="fp-controlArrow fp-next";var A=e(".fp-slides",y);A.parentNode.appendChild(u);A.parentNode.appendChild(D);c.loopHorizontal||(e(".fp-controlArrow.fp-prev",y).style.display=
"none")}if(c.slidesNavigation){y=g;u=m.createElement("div");u.className="fp-slidesNav";D=m.createElement("ul");u.appendChild(D);y.appendChild(u);y=e(".fp-slidesNav",y);u=e("ul",y);t(y,c.slidesNavPosition);D="";for(A=0;A<l;A++)D+='<li><a href="#"><span></span></a></li>';u.innerHTML+=D;y.style["margin-left"]="-"+y.offsetWidth/2+"px";l=p("li",y)[0];t(e("a",l),"active")}for(l=0;l<d.length;l++)d[l].style.width=f+"%";e(".fp-slide.active",g);t(d[0],"active")}h=p(".fp-controlArrow");for(k=0;k<h.length;k++)K(h[k],
"click onclick touchstart",Ya);ya(c.autoScrolling,"internal");h=e(".fp-section.active");k=e(".fp-slide.active",h);g=q(e(".fp-section.active"));k&&(0!==g||0===g&&0!==q(k))&&$a(k);c.navigation&&(x.style["margin-top"]="-"+x.offsetHeight/2+"px",k=p("li",x)[q(e(".fp-section.active"))],t(e("a",k),"active"));k=e(".fp-section.active");z(c.afterLoad)&&c.afterLoad.call(k,k.getAttribute("data-anchor"),q(k)+1);z(c.afterRender)&&c.afterRender.call(r);k=n.location.hash.replace("#","").split("/")[0];k.length&&(g=
e('[data-anchor="'+k+'"]'),!c.animateAnchor&&g.length&&(c.autoScrolling?L(g.offsetTop):(L(0),sa(k),d=U(g.offsetTop),ea(d.element,d.options,0)),Z(k,null),z(c.afterLoad)&&c.afterLoad.call(g,k,q(g)+1),B(h,"active"),t(g,"active")));sa();da(m,Xa,"DOMContentLoaded","DOMContentLoaded","DOMContentLoaded")},moveSectionUp:V,moveSectionDown:ha,moveTo:W,silentMoveTo:function(a,b){M(0,"internal");W(a,b);M(Q.scrollingSpeed,"internal")},moveSlideRight:X,moveSlideLeft:Y,setAutoScrolling:ya,setFitToSection:function(a,
b){T("fitToSection",a,b)},setKeyboardScrolling:function(a){c.keyboardScrolling=a},setRecordHistory:ga,setScrollingSpeed:M}});

/***/ }),

/***/ "fm8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fqse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"Estratégia","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/cliente/formulario","next":"/diagnotico"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g0Y6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMedia_vue__ = __webpack_require__("BOLP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a2ef2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMedia_vue__ = __webpack_require__("9dW/");
function injectStyle (ssrContext) {
  __webpack_require__("yUI4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6a2ef2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a2ef2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gMzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CultureAndLeadershipForm_vue__ = __webpack_require__("KfN7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe222784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CultureAndLeadershipForm_vue__ = __webpack_require__("2nCh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CultureAndLeadershipForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe222784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CultureAndLeadershipForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gmXK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center conclution"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"block-column conclution-go"},[_c('div',{staticClass:"conclution-button"},[_c('div',{staticClass:"conclution-square"}),_vm._v(" "),_c('router-link',{staticClass:"title",attrs:{"to":_vm.nextScreen}},[_c('span',[_vm._v("Ver resultado")]),_vm._v(" "),_c('icon',{attrs:{"name":"arrow-line-middle","width":"60px"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-column conclution-description"},[_c('h1',{staticClass:"title"},[_c('span',{staticClass:"active"},[_vm._v("Obrigado")]),_vm._v(" por participar do nosso teste de maturidade digital!")]),_vm._v(" "),_c('h2',{staticClass:"sub-title"},[_vm._v("Esperamos que, a partir daqui, você consiga enxergar melhor a jornada necessária para traçar a Transformação Digital da sua empresa. ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n        Disponilizamos o resultado do seu teste\n        "),_c('div',{staticClass:"small"},[_vm._v("além de enviá-lo para o e-mail cadastrado *")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gpHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__("QBAq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dc4ac4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__("7zJ7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dc4ac4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hSh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question-description"},[_c('div',{staticClass:"question-number"},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('div',{staticClass:"question-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"question-answer",class:_vm.answerClass},[_vm._v("\n      "+_vm._s(_vm.answer)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"question-form"},[_c('v-slider',{on:{"input":_vm.changeInput},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}),_vm._v(" "),_c('div',{staticClass:"applicable hidden-xs",on:{"click":function($event){$event.preventDefault();return _vm.applicableClick($event)}}},[_c('div',{staticClass:"text"},[_vm._v("Não aplicável")]),_vm._v(" "),_c('div',{staticClass:"checkbox"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iKC+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/moreresult.75b57b7.mp4";

/***/ }),

/***/ "ih3R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j6CX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jMCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-button',
  props: {
    to: String,
    href: {
      type: String,
      default: '#'
    },
    arrow: {
      type: Boolean,
      default: false
    },
    arrowLeft: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    superDark: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] }
});

/***/ }),

/***/ "jb5/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k1aN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderNav_vue__ = __webpack_require__("CU+x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d63816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderNav_vue__ = __webpack_require__("aV2R");
function injectStyle (ssrContext) {
  __webpack_require__("/PVP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63d63816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d63816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kHTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'empreendedorismo_digital',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/empreendedorismo-digital/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 6);
  }
});

/***/ }),

/***/ "kM6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationalAgilityForm_vue__ = __webpack_require__("dwPm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9970f418_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationalAgilityForm_vue__ = __webpack_require__("ZPg0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationalAgilityForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9970f418_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationalAgilityForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kNNL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationalAgility_vue__ = __webpack_require__("pqKq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef429d6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationalAgility_vue__ = __webpack_require__("9+OR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationalAgility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef429d6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationalAgility_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa656a60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("JHQ7");
function injectStyle (ssrContext) {
  __webpack_require__("bxX7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa656a60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa656a60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lmRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rollDown = {
  mounted: function mounted() {
    var _this = this;

    var waitAndGo = 0;
    var wheelToGo = 4;
    this.$el.addEventListener('wheel', function (e) {
      e.deltaY > 0 ? waitAndGo += 1 : waitAndGo -= 1;
      if (waitAndGo >= wheelToGo) {
        _this.$router.push(_this.nextScreen);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (rollDown);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateField", function() { return updateField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var updateField = function updateField(_ref, field) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* UPDATE_FIELD */], field);
};

/***/ }),

/***/ "myrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    half: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    width: String,
    height: String,
    color: {
      type: String,
      default: 'white'
    }
  }
});

/***/ }),

/***/ "nIg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customer',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/cliente/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
});

/***/ }),

/***/ "nShx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nY9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block-fullscreen-center block-fullscreen-text"},[_c('div',{staticClass:"title-main"},[_c('h1',[_vm._v("\n        Link de diagnóstico inválido.\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pqKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'agilidade_operacional',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/agilidade-operacional/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
});

/***/ }),

/***/ "pvIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("bQkl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vButton__ = __webpack_require__("wCtQ");
//
//
//
//
//
//
//
//
//
//
//
//





/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'empreendedorismo_digital-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */], vButton: __WEBPACK_IMPORTED_MODULE_2__vButton__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'empreendedorismo_digital',
      questions: this.$store.state.questions.empreendedorismo_digital
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 6);
  }
});

/***/ }),

/***/ "pxyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalMedia__ = __webpack_require__("g0Y6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_video_form_mp4__ = __webpack_require__("vaXp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_video_form_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_video_form_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_video_progress_mp4__ = __webpack_require__("07is");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_video_progress_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_video_progress_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_video_result_mp4__ = __webpack_require__("sp0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_video_result_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_video_result_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_video_youaredigital_mp4__ = __webpack_require__("KqHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_video_youaredigital_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_video_youaredigital_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_video_moreresult_mp4__ = __webpack_require__("iKC+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_video_moreresult_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_video_moreresult_mp4__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide-horizontal',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], ModalMedia: __WEBPACK_IMPORTED_MODULE_1__ModalMedia__["a" /* default */] },
  data: function data() {
    return {
      slideTransition: 'slide',
      totalItens: 2,
      current: 1,
      videos: {
        VideoForm: __WEBPACK_IMPORTED_MODULE_2__assets_video_form_mp4___default.a,
        VideoProgress: __WEBPACK_IMPORTED_MODULE_3__assets_video_progress_mp4___default.a,
        VideoResult: __WEBPACK_IMPORTED_MODULE_4__assets_video_result_mp4___default.a,
        VideoDigital: __WEBPACK_IMPORTED_MODULE_5__assets_video_youaredigital_mp4___default.a,
        VideoMoreResult: __WEBPACK_IMPORTED_MODULE_6__assets_video_moreresult_mp4___default.a
      },
      modalVideo: ''
    };
  },

  methods: {
    showItem: function showItem(media) {
      this.modalVideo = media;
    },
    closeModal: function closeModal() {
      this.modalVideo = '';
    },
    nextItem: function nextItem() {
      if (this.current < this.totalItens) {
        this.slideTransition = 'slide';
        this.current += 1;
      }
    },
    prevItem: function prevItem() {
      if (this.current > 1) {
        this.slideTransition = 'slide-left';
        this.current -= 1;
      }
    },
    setItem: function setItem(index) {
      if (index < this.current) {
        this.slideTransition = 'slide-left';
      } else {
        this.slideTransition = 'slide';
      }
      this.current = index;
    }
  }
});

/***/ }),

/***/ "q4MH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-questions"},[(_vm.title)?_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(question,index){return _c('question',{key:question.index,attrs:{"number":index + 1,"title":question.title,"reverse":question.reverse,"value":_vm.form[question.field],"field":question.field},on:{"input":_vm.rangeChange}})}),_vm._v(" "),(_vm.prev || _vm.next)?_c('div',{staticClass:"box-full-footer"},[(_vm.prev)?_c('v-button',{attrs:{"to":_vm.prev,"super-dark":"","arrow-left":""}},[_vm._v("\n      Voltar\n    ")]):_vm._e(),_vm._v(" "),(_vm.next)?_c('v-button',{attrs:{"to":_vm.next,"super-dark":"","arrow":""}},[_vm._v("\n      Avançar\n    ")]):_vm._e()],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qJD+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conclusion_vue__ = __webpack_require__("67o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b23746_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conclusion_vue__ = __webpack_require__("QrR7");
function injectStyle (ssrContext) {
  __webpack_require__("fm8j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18b23746"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b23746_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conclusion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rEL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-abstract block-fullscreen",class:{ 'is-mobile': _vm.mobile }},[_c('div',{staticClass:"header-logo",attrs:{"id":"headerLogo"}},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center result-page"},[_c('div',{attrs:{"id":"fullpage"}},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"result-percentage result-big bg-abstract-float"},[_c('h1',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.overall.title))]),_vm._v(" "),_c('div',{staticClass:"number-float"},[_vm._v(_vm._s(_vm.initResults.overall)+"%")])]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down",attrs:{"href":("#" + (_vm.slidesNames[1]))}},[_c('div',{staticClass:"title hidden-xs hidden-sm"},[_vm._v("\n            Role para baixo\n          ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"result-bar"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.resultText.overall.text)}}),_vm._v(" "),_c('div',{staticClass:"categories-bars"},[_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("CULTURA E LIDERANÇA")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.cultura_e_lideranca))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.cultura_e_lideranca)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("AGILIDADE OPERACIONAL")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.agilidade_operacional))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.agilidade_operacional)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("TECNOLOGIA DIGITAL")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.tecnologia_digital))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.tecnologia_digital)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("EXPERIÊNCIA DO CLIENTE")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.experiencia_do_cliente))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.experiencia_do_cliente)+"%")])]),_vm._v(" "),_c('div',{staticClass:"category-bar"},[_c('div',{staticClass:"category"},[_vm._v("EMPREENDEDORISMO DIGITAL")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"fill",style:(_vm.widthPercentage(_vm.initResults.empreendedorismo_digital))})]),_vm._v(" "),_c('div',{staticClass:"number-percentage"},[_vm._v(_vm._s(_vm.initResults.empreendedorismo_digital)+"%")])])])]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down hidden-xs",attrs:{"href":("#" + (_vm.slidesNames[2]))}},[_c('icon',{staticClass:"animation-blink",attrs:{"name":"arrow-small-down"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section result-categories"},[_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("CULTURA E LIDERANÇA")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.cultura_e_lideranca.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultcultura_e_lideranca"}},[_vm._v(_vm._s(_vm.initResults.cultura_e_lideranca)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.cultura_e_lideranca.text)}})]),_vm._v(" "),_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("AGILIDADE OPERACIONAL")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.agilidade_operacional.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultcultura_e_lideranca"}},[_vm._v(_vm._s(_vm.initResults.agilidade_operacional)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.agilidade_operacional.text)}})]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down hidden-xs",attrs:{"href":("#" + (_vm.slidesNames[3]))}},[_c('icon',{staticClass:"animation-blink",attrs:{"name":"arrow-small-down"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section result-categories"},[_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("TECNOLOGIA DIGITAL")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.tecnologia_digital.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resulttecnologia_digital"}},[_vm._v(_vm._s(_vm.initResults.tecnologia_digital)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.tecnologia_digital.text)}})]),_vm._v(" "),_c('div',{staticClass:"result-category"},[_c('div',{staticClass:"category"},[_vm._v("EXPERIÊNCIA DO CLIENTE")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.experiencia_do_cliente.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resulttecnologia_digital"}},[_vm._v(_vm._s(_vm.initResults.experiencia_do_cliente)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.experiencia_do_cliente.text)}})]),_vm._v(" "),_c('a',{staticClass:"nav-arrow-down hidden-xs",attrs:{"href":("#" + (_vm.slidesNames[4]))}},[_c('icon',{staticClass:"animation-blink",attrs:{"name":"arrow-small-down"}})],1)]),_vm._v(" "),_c('section',{staticClass:"section result-categories"},[_c('div',{staticClass:"result-category center"},[_c('div',{staticClass:"category"},[_vm._v("EMPREENDEDORISMO DIGITAL")]),_vm._v(" "),_c('div',{staticClass:"result-percentage"},[_c('h2',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.resultText.empreendedorismo_digital.title))]),_vm._v(" "),_c('div',{staticClass:"number-float",attrs:{"id":"resultempreendedorismo_digital"}},[_vm._v(_vm._s(_vm.initResults.empreendedorismo_digital)+"%")])]),_vm._v(" "),_c('div',{staticClass:"result-description",domProps:{"innerHTML":_vm._s(_vm.resultText.empreendedorismo_digital.text)}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rXno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessForm_vue__ = __webpack_require__("CpKd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3c6b8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessForm_vue__ = __webpack_require__("9FJ6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3c6b8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "reIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobile_detect__ = __webpack_require__("UMwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__("R5/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min__ = __webpack_require__("fP26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg__ = __webpack_require__("MICb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png__ = __webpack_require__("cf9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var isMobile = false;

if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  isMobile = true;
};

/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'result',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */] },
  data: function data() {
    return {
      //slidesNames: ['final', 'geral', 'categoria1', 'categoria2', 'categoria3', 'compartilhe'],
      slidesNames: ['final', 'geral', 'categoria1', 'categoria2', 'categoria3'],
      nextScreen: '/result',
      initResults: {
        cultura_e_lideranca: 0,
        agilidade_operacional: 0,
        tecnologia_digital: 0,
        experiencia_do_cliente: 0,
        empreendedorismo_digital: 0,
        overall: 0
      },
      test_results: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$store.state.test_results),
      resultText: {
        overall: { text: '', title: '' },
        cultura_e_lideranca: { text: '', title: '' },
        tecnologia_digital: { text: '', title: '' },
        agilidade_operacional: { text: '', title: '' },
        experiencia_do_cliente: { text: '', title: '' },
        empreendedorismo_digital: { text: '', title: '' }
      },
      dataResultText: {
        overall: [{ maxScore: 20, title: 'Você está no começo da jornada', text: '<p>Percebemos que você tem um longo caminho a percorrer rumo à maturidade digital. Mas não encare isso com desânimo, veja como uma grande oportunidade para o seu desenvolvimento pessoal e profissional. Para a transformação digital acontecer é necessário que as pessoas estejam dispostas a se capacitar e a evoluir em suas áreas de atuação.</p><p>Entender bem os conceitos ao redor da transformação digital é a prioridade para você nesse momento. Está pronto para começar?</p>' }, { maxScore: 40, title: 'Você já deu alguns passos, agora é perseverar!', text: '<p>Alguns pontos do contexto da transformação digital já não são novidade para você. Porém é preciso compreendê-los com maior profundidade, além de expandir sua área de conhecimento. Alcançar a maturidade digital exige muitas vezes pensar diferente do modo que estamos habituados ou buscar alternativas para processos que podem ser otimizados.</p><p>Avalie as dimensões em que você obteve desempenho inferior e busque aprofundar-se nos temas que ainda desconhece.</p>' }, { maxScore: 60, title: 'O digital é uma meta tangível para você', text: '<p>Pensar no contexto digital já é mais tangível para você. Isso te coloca à frente de muita gente no mercado. Entretanto, ainda temos um bom percurso a percorrer. Tenha como objetivo dominar as dimensões da transformação digital que destacamos, analisando desde cultura digital, até aspectos técnicos da tecnologia e agilidade operacional, sem deixar de lado o empreendedorismo e a experiência do cliente.</p><p>Mesmo que sua função hoje não exija conhecimento aprofundado em todos esses tópicos, vale lembrar que eles são essenciais para alcançar a maturidade digital. Mantenha o foco e sucesso na jornada!</p>' }, { maxScore: 70, title: 'Você alcançou nível satisfatório de maturidade digital', text: '<p>Percebemos que você já possui conhecimento e tem executa práticas do contexto da transformação digital que dão mais eficiência ao seu dia a dia. Agora o foco é evoluir alguns pontos para levar você ao estágio de excelência.</p><p>A dica para você é: "ouse mais dentro do digital!". Explore seu mindset digital para sustentar as mudanças que a transformação digital agrega em pessoas, processos e ferramentas. Pesquise novas alternativas e compartilhe com outros profissionais as experiências possíveis de implementação no seu cenário atual. Continue, falta pouco!</p>' }, { maxScore: 80, title: 'Sorria, você alcançou nível satisfatório de maturidade digital', text: '<p>Percebemos que você já possui conhecimento e tem executa práticas do contexto da transformação digital que dão mais eficiência ao seu dia a dia. Agora o foco é evoluir alguns pontos para levar você ao estágio de excelência.</p><p>A dica para você é: "ouse mais dentro do digital!". Explore seu mindset digital para sustentar as mudanças que a transformação digital agrega em pessoas, processos e ferramentas. Pesquise novas alternativas e compartilhe com outros profissionais as experiências possíveis de implementação no seu cenário atual. Continue, falta pouco!</p>' }, { maxScore: 100, title: 'Parabéns! Você alcançou um alto nível de maturidade digital', text: '<p>O contexto da transformação digital já faz parte da sua expertise e isso coloca você como um profissional apto a desbravar novos desafios nesse cenário de mudanças. Aliás, ser um agente de mudanças é uma habilidade fundamental no cenário corporativo da nova economia.</p><p>Mantenha o foco na evolução e no aprendizado contínuo sobre transformação digital. Como você sabe, mesmo quem está à frente não pode parar. Avalie ainda pontos que você ter maior efetividade e vamos em frente!</p>' }],
        cultura_e_lideranca: [{ maxScore: 20, title: 'Desenvolva seu mindset digital', text: '<p>Uma cultura fortalecida no contexto digital é fundamental para que a transformação aconteça. É imprescindível uma mudança na forma como se pensa a relação com as pessoas, as ferramentas e os processos da empresa para alcançar bons resultados na transformação digital. Foque em crescer nesses aspectos!</p><p>Além disso, tenha em vista que assumir a liderança da disrupção pode fazer de você um profissional de destaque no mercado.</p>' }, { maxScore: 40, title: 'A transformação passa pela sua cultura', text: '<p>Transformação digital não quer dizer apenas sobre tecnologia, as pessoas são essenciais para o êxito de uma empresa nesse novo cenário. E quando falamos em pessoas incluímos a forma como elas interagem com esse novo contexto de disrupção.</p><p>Invista no desenvolvimento de um novo mindset, aberto às possibilidades de mudança que a transformação digital oferece.</p>' }, { maxScore: 60, title: 'Já sabe a importância de pensar diferente', text: '<p>A forma como você se posiciona diante de alguns desafios da transformação digital sinalizam sua abertura ao pensamento disruptivo. Porém, para chegar a ser um verdadeiro líder nesse contexto é necessário assumir mais riscos e quebrar outros paradigmas.</p><p>Você está no caminho! Agora é buscar se desenvolver para encontrar um ambiente disponível e propício às mudanças que os próximos anos esperam.</p>' }, { maxScore: 80, title: 'Agora desbrave novos mares', text: '<p>Você tem características que te posicionam mais à dianteira quando falamos na forma de pensar a transformação digital. Aproveite sua abertura ao pensamento disruptivo para consolidar o mindset digital e desenvolver habilidades fundamentais a um líder do contexto digital.</p><p>Participe mais de conversas com pessoas que possuem um mindset digital amadurecido. Lembre-se que o compartilhamento de ideias fortalece nossa cultura.</p>' }, { maxScore: 100, title: 'Muito bem, agora é só fazer acontecer', text: '<p>Acreditamos que o primeiro passo para uma verdadeira transformação digital parte da forma como as pessoas pensam e atuam nesse novo cenário. E você demonstrou estar preparado para se aventurar nas novas possibilidades que o mundo digital reserva.</p><p>Continue desenvolvendo-se, compartilhe conhecimento e ajude aqueles que estão próximos de você a também se abrirem a um mindset digital.</p>' }],
        agilidade_operacional: [{ maxScore: 20, title: 'Cuidado com a improdutividade', text: '<p>Você ainda está condicionado a processos analógicos, o que no cenário de transformação digital pode significar um atraso para a evolução. Ao longo da história vimos os processos serem substituídos por modelos mais efetivos, agora estamos em mais um momento desses.</p><p>É hora de investir no conhecimento de metodologias ágeis e novos modelos de resolução de problemas que incluem soluções digitais.</p>' }, { maxScore: 40, title: 'Go ahead, my friend!', text: '<p>Você já percebeu que alguns processos podem ser feitos de maneira diferente. Esse é o primeiro passo! Agora é preciso investir mais tempo e esforço na busca por novas formas de executar as tarefas do seu dia a dia.</p><p>Ter mais agilidade operacional no contexto digital não é opcional. Infelizmente, você pode ficar para trás caso não queira acelerar.</p>' }, { maxScore: 60, title: 'Eu não vim até aqui pra desistir agora...', text: '<p>Você está praticamente no meio do caminho: já entendeu que é possível ter mais efetividade nos processos, mas ainda precisa ganhar mais experiência na aplicação de metodologias ágeis.</p><p>Busque compreender melhor como as ferramentas podem auxiliar nos processos de desenvolvimento de projetos e explore novas possibilidades no seu contexto de trabalho.</p>' }, { maxScore: 80, title: 'Estamos num bom ritmo', text: '<p>Processos colaborativos, automação de tarefas e modelos disruptivos para resolução de problemas já não são monstros para você. E isso é muito bom!</p><p>A ideia agora é evoluir. Busque mais conhecimento sobre esses tópicos e teste possibilidades desde a execução de tarefas simples a grandes projetos.</p>' }, { maxScore: 100, title: 'Agilidade e eficiência são seu sobrenome', text: '<p>É ótimo saber que você compreende a aplicação prática das metodologias ágeis e a importância de desenhar/executar processos buscando maior efetividade com ajuda de soluções digitais.</p><p>Colaborar com a construção de ambientes colaborativos, mantendo-os ativos e com pessoas engajadas é o caminho para estar sempre em evolução.</p>' }],
        tecnologia_digital: [{ maxScore: 20, title: 'Ela veio para ajudar', text: '<p>A evolução tecnológica gera benefícios para as pessoas, negócios, sociedade... enfim, é um caminho sem volta. Não espere mais um dia para começar a conhecer mais sobre esse pilar da transformação digital.</p><p>Temas como análise de dados, automação, mobilidade, atendimento digital já estão mais comuns no cotidiano das pessoas e são um bom ponto de partida nessa jornada de conhecimento. Siga em frente!</p>' }, { maxScore: 40, title: 'Ela veio pra ficar!', text: '<p>Você já notou que a tecnologia digital veio pra ficar e transformar o cotidiano das pessoas. Agora é dedicar-se a entender um pouco mais sobre como a aplicação dessas tecnologias vão gerar benefícios no nosso dia a dia.</p><p>Além disso, implantar estratégias com base em análise de dados e utilizar tecnologias/ferramentas adequadas podem garantir a existência do seu negócio nos próximos anos.</p>' }, { maxScore: 60, title: 'Algumas coisas estão claras, outras nem tanto', text: '<p>Que tal elucidar de vez as dúvidas sobre os conceitos de tecnologia que fazem parte da transformação digital? Essa deve ser sua meta para aumentar seu nível de maturidade digital.</p><p>Boa parte das tecnologias que citamos no diagnóstico você provavelmente já ouviu falar, agora é entender como elas podem ser aplicadas no cotidiano do seu trabalho para gerar mais resultados.</p>' }, { maxScore: 80, title: 'Isso é sobre resultados', text: '<p>E os resultados podem ser: mais agilidade, melhor experiência, mais lucratividade, e muitas coisas boas quando aplicamos a tecnologia ideal no nosso cenário corporativo. Identificar a necessidade de usar tecnologias/ferramentas já é tangível para você, mas saber como elas trarão resultados efetivos está entre os pontos a evoluir.</p><p>Falta pouco para você conseguir resultados ainda mais extraordinários. Que tal fazer um review de estudos sobre os principais conceitos que fazem parte da transformação digital com foco em aplicação e geração de resultados?</p>' }, { maxScore: 100, title: 'Gostamos de ver', text: '<p>Você conhece os principais tópicos que fazem parte do pilar tecnologia quando falamos em transformação digital. O impacto do uso de dados para tomada de decisões, a aplicação estratégica de ferramentas para otimização de resultados e os benefícios das tecnologias emergentes já são pauta frequente no seu dia a dia.</p><p>Apenas lembre-se que a respeito de tecnologia não podemos ficar parados. Continue estudando, aplicando, testando e se desenvolvendo. O futuro é logo ali!</p>' }],
        experiencia_do_cliente: [{ maxScore: 20, title: '"Experiência do cliente" não é modismo', text: '<p>"Experiência do cliente" é necessidade. E isso deveria estar entre as pautas principais de toda empresa, já que entender sua força no atual cenário digital é o caminho para se manter relevante e não naufragar.</p><p>Comece entendendo melhor os hábitos e as expectativas dos consumidores. Invista em conhecer também sobre jornada de compra e como criar uma melhor experiência em cada estágio.</p>' }, { maxScore: 40, title: 'Aprenda mais com seu cliente', text: '<p>Engana-se quem pensa que é possível criar uma boa experiência sem falar com clientes. O seu produto/serviço existe para suprir uma necessidade do seu cliente, se você não o conhece (de verdade), como poderá ajudá-lo?</p><p>Experiência tem a ver com comportamento, impacto, resolver problemas, facilidades, expectativas. Invista tempo e recursos para entender melhor seu cliente e melhore seu produto/serviço agregando mais valor.</p>' }, { maxScore: 60, title: 'Só falta investir um pouco mais em experiência', text: '<p>Você já sabe quem é o seu cliente e o que ele precisa quando busca o seu produto/serviço. Agora é hora de valorizar mais a experiência que ele tem durante toda a jornada de compra.</p><p>Revise os estágios da jornada de compra e o processo de pós-vendas identificando formas de melhorar a experiência do seu cliente. Lembre-se que ele deve se sentir seguro e satisfeito por ter escolhido fazer negócio com a sua empresa.</p>' }, { maxScore: 80, title: 'Explore novas possibilidades', text: '<p>"Experiência do cliente" já faz parte do seu vocabulário e você já entendeu a importância desse fator na estratégia do seu produto/serviço.</p><p>O caminho agora é explorar formas de surpreender o seu cliente, testar possibilidades e/ou encontrar novas maneiras de agregar valor (lembrando que valor é diferente de preço) ao seu produto/serviço.</p>' }, { maxScore: 100, title: 'Seus clientes devem ser seus fãs', text: '<p>Parabéns. Você cuida e valoriza o seu cliente! Esse é o sentimento que ele tem quando você explora maneiras de gerar uma ótima experiência.</p><p>Invista continuamente em experiências únicas para seus clientes e que ajudem seu produto/serviço a subir degraus na liderança do seu nicho de mercado. Traduzir as expectativas do seu cliente em entregas potencializadas pelo digital é o caminho que  pode te levar além.</p>' }],
        empreendedorismo_digital: [{ maxScore: 20, title: 'Todos podem ser empreendedores', text: '<p>Empreender não significa apenas criar novos negócios, podemos também empreender dentro dos nossos setores de trabalho.</p><p>O importante é ter um "espírito empreender", um desejo constante de encontrar novas possibilidades, de resolver problemas, de sermos produtivos. Esse é o nosso convite para você a partir de agora!</p>' }, { maxScore: 40, title: 'Não precisa ter medo', text: '<p>Às vezes quando falamos em disrupção, crescimento de negócios, networking parece algo distante (ou difícil), porém são conceitos que podem ser aplicados apenas com um pouco de dedicação no nosso dia a dia.</p><p>Aproveita que você já tem noção de alguns aspectos do empreendedorismo digital e perca o receio de investir tempo para se aprofundar nesses conceitos. Empreender faz a diferença não só em negócios do futuro, mas no seu trabalho hoje.</p>' }, { maxScore: 60, title: 'Está ficando legal', text: '<p>Produtividade, disrupção e crescimento já são termos familiares para você. Mas para ficar melhor, vale a pena descobrir agora como trazer mais crescimento com um pensamento disruptivo na solução dos problemas da sua empresa ou de seus clientes.</p><p>Desafie-se a descobrir novas formas de superar obstáculos, de ser mais produtivo e/ou de traçar metas tangíveis e mensuráveis para concluir projetos estagnados.</p>' }, { maxScore: 80, title: 'Um leque de oportunidades', text: '<p>É assim que a vida é para verdadeiros empreendedores, a cada novo desafio eles enxergam um leque de oportunidades. Percebemos que você tem grande potencial para chegar nesse nível.</p><p>Aproveite para analisar os projetos/trabalhos que você participa/executa atualmente e tente idealizar novas soluções para problemas corriqueiros. Expandir o networking, saber o que acontece no seu mercado de atuação e desenvolver o mindset digital são pontos que nunca podem sair de vista.</p>' }, { maxScore: 100, title: 'Pronto para fazer a diferença', text: '<p>Você possui as habilidades necessárias para trabalhar em alta performance e gerar resultados efetivos em novos negócios e/ou em projetos que já estejam em execução.</p><p>Continue nesse caminho de disrupção, com um mindset digital, focado em produtividade e resultados efetivos, sem perder a criatividade que deve fazer parte de todo empreendedor. Ajude também seus colegas de trabalho a evoluírem e fortaleça seu networking local.</p>' }]
      },
      faceBook: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    window.$loadImages([__WEBPACK_IMPORTED_MODULE_8__assets_img_bg_abstract_jpg___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_img_abstract_float_png___default.a]).then(function () {
      return next();
    });
  },
  mounted: function mounted() {
    var _this = this;

    /* eslint-disable */
    window.fbAsyncInit = function () {
      FB.init({
        appId: '398443737018854',
        xfbml: true,
        version: 'v2.12'
      });
      FB.AppEvents.logPageView();
      _this.faceBook = FB;
    };

    (function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);js.id = id;
      js.src = 'https://connect.facebook.net/pt_BR/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    /* eslint-enable */

    this.processResultText();
    var logo = document.getElementById('headerLogo');

    isMobile && this.animateNumbers(['overall', 'cultura_e_lideranca', 'tecnologia_digital', 'agilidade_operacional', 'experiencia_do_cliente', 'empreendedorismo_digital'], false);

    !isMobile && __WEBPACK_IMPORTED_MODULE_7__static_js_javascript_fullPage_min___default.a.initialize('#fullpage', {
      anchors: this.slidesNames,
      navigation: false,
      scrollBar: true,
      afterLoad: function afterLoad(anchor) {
        switch (anchor) {
          case _this.slidesNames[0]:
            _this.animateNumbers(['overall']);
            break;
          case _this.slidesNames[1]:
            _this.animateNumbers(['cultura_e_lideranca', 'tecnologia_digital', 'agilidade_operacional', 'experiencia_do_cliente', 'empreendedorismo_digital'], false);
            break;
          case _this.slidesNames[2]:
            _this.animateNumbers(['cultura_e_lideranca', 'agilidade_operacional']);
            break;
          case _this.slidesNames[3]:
            _this.animateNumbers(['tecnologia_digital', 'experiencia_do_cliente']);
            break;
          case _this.slidesNames[4]:
            _this.animateNumbers(['empreendedorismo_digital']);
            break;
        }
      },
      onLeave: function onLeave(index, nextIndex) {
        if (nextIndex === _this.slidesNames.length) {
          logo.style.animationName = 'fade-to-bottom';
        } else logo.style.animationName = 'fade-to-bottom-reverse';
      }
    });
  },

  computed: {
    mobile: function mobile() {
      return !!new __WEBPACK_IMPORTED_MODULE_4_mobile_detect___default.a(window.navigator.userAgent).phone();
    },
    shareLinkedinUrl: function shareLinkedinUrl() {
      var url = encodeURI('https://score.transformacaodigital.com/');
      var text = encodeURI('Meu resultado foi ' + this.initResults.overall + '% - "' + this.resultText.overall.title + '". Descubra o seu: ' + url);
      return 'https://www.linkedin.com/shareArticle?url=' + url + '&summary=' + text;
    },
    shareTwitterUrl: function shareTwitterUrl() {
      var text = encodeURI('Meu resultado foi ' + this.initResults.overall + '% - "' + this.resultText.overall.title + '". Descubra o seu:');
      var url = encodeURI('https://score.transformacaodigital.com/');
      var hashtags = encodeURI('TransformaçãoDigital,MaturidadeDigital,TDScore');
      return 'https://twitter.com/share?url=' + url + '&hashtags=' + hashtags + '&text=' + text;
    }
  },
  methods: {
    shareFaceBook: function shareFaceBook() {
      /* eslint-disable */
      console.log('-- faceBook');
      console.log(this.faceBook);
      console.log('-- FB');
      console.log(FB);
      FB.ui({
        method: 'share',
        href: 'http://tdscore.herokuapp.com/',
        hashtag: '#tdscore',
        quote: 'Teste quote'
      }, function (response) {
        console.log(response);
      });
      /* eslint-enable */
    },
    processResultText: function processResultText() {
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.dataResultText);
      for (var i = 0; i < keys.length; i += 1) {
        this.scoreText(keys[i]);
      }
    },
    scoreText: function scoreText(score) {
      var scoreField = this.test_results['' + score];
      for (var i = 0; i < this.dataResultText[score].length; i += 1) {
        var dataText = this.dataResultText[score][i];
        if (scoreField <= dataText.maxScore) {
          this.resultText[score] = {
            text: dataText.text,
            title: dataText.title
          };
          break;
        }
      }
    },
    animateNumbers: function animateNumbers(fields) {
      var _this2 = this;

      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var optionFields = [];
      for (var i = 0; i < fields.length; i += 1) {
        if (reset) this.initResults[fields[i]] = 0;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(optionFields, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, fields[i], this.test_results[fields[i]]));
      }
      __WEBPACK_IMPORTED_MODULE_5_gsap__["a" /* TweenMax */].to(this.initResults, 1, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, optionFields, {
        onUpdate: function onUpdate() {
          for (var _i = 0; _i < fields.length; _i += 1) {
            _this2.initResults[fields[_i]] = Math.ceil(_this2.initResults[fields[_i]]);
          }
        }
      }));
    },
    widthPercentage: function widthPercentage(value) {
      return 'width:' + value + '%';
    }
  }
});

/***/ }),

/***/ "ripP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("myrB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3630894_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("HT91");
function injectStyle (ssrContext) {
  __webpack_require__("NAED")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3630894_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rtiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroForm_vue__ = __webpack_require__("3/iJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c696350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroForm_vue__ = __webpack_require__("wWYq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c696350_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sBMc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tecnologia_digital',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/teste/tecnologia-digital/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
});

/***/ }),

/***/ "sOkK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__ = __webpack_require__("reIN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c6b49c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__ = __webpack_require__("rEL5");
function injectStyle (ssrContext) {
  __webpack_require__("nShx")
  __webpack_require__("zadC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63c6b49c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c6b49c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "smTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Diagnosis_vue__ = __webpack_require__("ylXp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fd23a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Diagnosis_vue__ = __webpack_require__("v+lT");
function injectStyle (ssrContext) {
  __webpack_require__("M6BB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14fd23a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Diagnosis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fd23a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Diagnosis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sp0J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/result.e3dd951.mp4";

/***/ }),

/***/ "svej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__("998L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vButton__ = __webpack_require__("wCtQ");
//
//
//
//
//
//
//
//
//
//
//
//





/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'strategy-form',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */], Questions: __WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */], vButton: __WEBPACK_IMPORTED_MODULE_2__vButton__["a" /* default */] },
  data: function data() {
    return {
      keyForm: 'strategy',
      questions: [{ field: 'td_strategy_infra', title: 'A empresa possui estrutura para a implementação de novos processos digitais.' }, { field: 'td_digital_first', title: 'Digital first: quando precisamos integrar meios digital e offline, normalmente a estratégia digital é adaptada e remodelada para o offline, e não o contrário.' }, { field: 'td_measurement', title: 'Existem métricas bem definidas para a análise dos resultados de estratégias digitais.' }, { field: 'td_security', title: 'A empresa tem a segurança digital como uma de suas prioridades.' }, { field: 'td_team_readyness', title: 'Existe uma pessoa ou um time dedicado à Transformação Digital.' }, { field: 'td_communication_clarity', title: 'A estratégia digital da empresa está clara para todos os colaboradores.' }, { field: 'td_goal_solution', title: 'Buscam-se soluções e iniciativas digitais para o alcance de metas gerais da empresa.' }, { field: 'td_data_unity', title: 'As informações e dados da empresa estão consolidadas em um único ambiente digital, que centraliza o conhecimento e documentos gerando ganho de eficiência.' }]
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('CALCULATE_OVERALL');
  }
});

/***/ }),

/***/ "swjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"TECNOLOGIA DIGITAL","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/teste/agilidade-operacional/formulario","next":"/teste/experiencia-do-cliente"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uAKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('bar-progress'),_vm._v(" "),_c('request-error'),_vm._v(" "),_c('transition',{attrs:{"name":"fade-up","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uDv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"EXPERIÊNCIA DO CLIENTE","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/teste/tecnologia-digital/formulario","next":"/teste/empreendedorismo-digital"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uHss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Strategy_vue__ = __webpack_require__("+bH1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f60dca8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Strategy_vue__ = __webpack_require__("Ujtj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Strategy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f60dca8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Strategy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uXHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__ = __webpack_require__("lmRr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intro',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rollDown__["a" /* default */]],
  components: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  data: function data() {
    return {
      nextScreen: '/intro/formulario'
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 1);
  }
});

/***/ }),

/***/ "ucjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center block-step block-fullscreen-text"},[_c('h1',{staticClass:"title-section"},[_vm._v("EXPERIÊNCIA DO CLIENTE")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"nav-arrow-down",attrs:{"to":_vm.nextScreen}},[_c('div',{staticClass:"title hidden-sm"},[_vm._v("\n        Role para baixo\n      ")]),_vm._v(" "),_c('icon',{staticClass:"arrow-right animation-blink",attrs:{"name":"arrow-line-right"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('p',[_vm._v("O conceito de experiência do cliente é amplamente abordado na jornada de transformação digital. A maioria das ações que fazemos nas empresas tem como finalidade as pessoas. Logo elas assumem um papel central quando são consideradas nossos clientes.")]),_vm._v(" "),_c('p',[_vm._v("Sendo o cliente todo aquele que consome o seu produto e/ou serviço, vamos conferir algumas questões relevantes desse cenário.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_BAR_PROGRESS */], function (state, value) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'barProgress', value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* REQUEST_ERROR */], function (state, value) {
  console.log(value);
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'requestError', value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* UPDATE_FIELD */], function (state, _ref) {
  var form = _ref.form,
      key = _ref.key,
      value = _ref.value;

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state[form], key, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SUBMITTED */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'submitted', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CALCULATE_OVERALL */], function (state) {

  var overall = 0;
  var sum = 0;
  var results = ['td_score_understanding', 'td_score_people', 'td_score_process', 'td_score_customer_experience', 'td_score_strategy'];
  for (var i = 0; i < results.length; i += 1) {
    sum += state.results[results[i]];
  }
  overall = Math.ceil(sum / results.length);
  console.log(state);
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.results, 'td_score_overall', overall);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* TEST_CALCULATE_OVERALL */], function (state) {
  var overall = 0;
  var sum = 0;
  var results = ['cultura_e_lideranca', 'experiencia_do_cliente', 'empreendedorismo_digital', 'tecnologia_digital', 'agilidade_operacional'];
  for (var i = 0; i < results.length; i += 1) {
    sum += state.test_results[results[i]];
  }
  overall = Math.floor(sum / results.length);
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.test_results, 'overall', overall);
}), _mutations);

/***/ }),

/***/ "v+lT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.stepCurrent == 1)?_c('section',{key:1,staticClass:"box-full box-form",attrs:{"id":"formSegment"}},[_c('h1',{staticClass:"title"},[_c('span',[_vm._v("Escolha")]),_vm._v(" "),_c('span',[_vm._v("seu")]),_vm._v(" "),_c('span',[_vm._v("segmento")]),_vm._v(" "),_c('span',[_vm._v("para")]),_vm._v(" "),_c('span',{staticClass:"active"},[_vm._v("finalizar")])]),_vm._v(" "),_c('div',{staticClass:"box-select"},[_c('div',{staticClass:"row"},[_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 1 },attrs:{"href":"#","data-id":"1"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Agência de Marketing e Publicidade")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 2 },attrs:{"href":"#","data-id":"2"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Consultorias e Treinamentos")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 3 },attrs:{"href":"#","data-id":"3"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("E-commerce")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 4 },attrs:{"href":"#","data-id":"4"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Educação e Ensino")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 5 },attrs:{"href":"#","data-id":"5"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Engenharia e Indústria Geral")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 6 },attrs:{"href":"#","data-id":"6"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Eventos")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 7 },attrs:{"href":"#","data-id":"7"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Financeiro, Jurídico e  relacionados")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 8 },attrs:{"href":"#","data-id":"8"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Governo e Órgãos Públicos")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 9 },attrs:{"href":"#","data-id":"9"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Hardware e Eletrônicos")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 10 },attrs:{"href":"#","data-id":"10"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Imobiliárias")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 11 },attrs:{"href":"#","data-id":"11"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Mídia e Comunicação")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 12 },attrs:{"href":"#","data-id":"12"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("ONGs")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 13 },attrs:{"href":"#","data-id":"13"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Saúde e Estética")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 14 },attrs:{"href":"#","data-id":"14"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Serviços em RH e Coaching")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 15 },attrs:{"href":"#","data-id":"15"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Software e Cloud")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 16 },attrs:{"href":"#","data-id":"16"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Telecomunicações")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 17 },attrs:{"href":"#","data-id":"17"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Turismo e Lazer")]),_vm._v(" "),_c('a',{staticClass:"box-item",class:{ active: _vm.segmentCurrent == 18 },attrs:{"href":"#","data-id":"18"},on:{"click":function($event){$event.preventDefault();return _vm.selectBox($event)}}},[_vm._v("Varejo")])])]),_vm._v(" "),_c('div',{staticClass:"box-full-footer"},[_c('v-button',{staticClass:"btn-prev",attrs:{"to":"/estrategia/formulario","super-dark":"","arrow-left":""}},[_vm._v("\n          Voltar\n        ")]),_vm._v(" "),_c('icon',{staticClass:"td-logo",attrs:{"name":"td-logo","color":"#393f49"}}),_vm._v(" "),(_vm.segmentCurrent)?_c('v-button',{staticClass:"btn-next",attrs:{"super-dark":"","arrow":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.nextStep($event)}}},[_vm._v("\n          Avançar\n        ")]):_c('v-button',{staticClass:"btn-next",attrs:{"super-dark":""}},[_vm._v("\n          Selecione um segmento\n        ")])],1)]):_vm._e(),_vm._v(" "),(_vm.stepCurrent == 2)?_c('section',{key:2,staticClass:"box-full box-form"},[_c('h1',{staticClass:"title title-form"},[_vm._v("Insira seus dados")]),_vm._v(" "),_c('div',{staticClass:"form-steps",attrs:{"id":"forms"}},[_c('a',{staticClass:"nav-arrow nav-left",class:{ 'v-hidden': _vm.stepFormCurrent == 1 },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.prevForm()}}},[_c('icon',{attrs:{"name":"arrow-right","half":""}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.stepFormCurrent == 1)?_c('form',{key:1,staticClass:"form-step",on:{"submit":function($event){$event.preventDefault();_vm.nextForm()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.firstname),expression:"form.firstname"}],staticClass:"form-input",attrs:{"type":"text","name":"firstname","required":"","placeholder":"Nome"},domProps:{"value":(_vm.form.firstname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "firstname", $event.target.value)},_vm.inputChange]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-input",class:{ error: _vm.errorValidationForm.email },attrs:{"type":"email","name":"email","placeholder":"Email","required":""},domProps:{"value":(_vm.form.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)},_vm.inputChange]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.company),expression:"form.company"}],staticClass:"form-input",attrs:{"type":"empresa","name":"company","required":"","placeholder":"Empresa"},domProps:{"value":(_vm.form.company)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "company", $event.target.value)},_vm.inputChange]}}),_vm._v(" "),_c('v-multiselect',{class:{ error: _vm.errorValidationForm.estado_sigla },attrs:{"autocomplete":"off","options":_vm.state,"show-labels":false,"placeholder":"Estado","label":"state","value":_vm.form.estado_sigla,"track-by":"sigla","id":"estado_sigla"},on:{"select":_vm.multiselectChange},model:{value:(_vm.form.estado_sigla),callback:function ($$v) {_vm.$set(_vm.form, "estado_sigla", $$v)},expression:"form.estado_sigla"}}),_vm._v(" "),_c('v-multiselect',{class:{ error: _vm.errorValidationForm.business_model },attrs:{"options":_vm.model,"show-labels":false,"placeholder":"Modelo de negócio","id":"business_model"},on:{"select":_vm.multiselectChange},model:{value:(_vm.form.business_model),callback:function ($$v) {_vm.$set(_vm.form, "business_model", $$v)},expression:"form.business_model"}}),_vm._v(" "),_c('button',{ref:"submitStep1",attrs:{"type":"submit","hidden":""}})],1):_vm._e(),_vm._v(" "),(_vm.stepFormCurrent == 2)?_c('div',{key:2,staticClass:"form-step"},[_c('v-multiselect',{class:{ error: _vm.errorValidationForm.numemployees },attrs:{"options":_vm.employees,"show-labels":false,"placeholder":"Quantidade de funcionários","id":"numemployees"},on:{"select":_vm.multiselectChange},model:{value:(_vm.form.numemployees),callback:function ($$v) {_vm.$set(_vm.form, "numemployees", $$v)},expression:"form.numemployees"}}),_vm._v(" "),_c('v-multiselect',{class:{ error: _vm.errorValidationForm.td_cargo },attrs:{"options":_vm.role,"show-labels":false,"placeholder":"Cargo","id":"td_cargo"},on:{"select":_vm.changeCargo},model:{value:(_vm.form.td_cargo),callback:function ($$v) {_vm.$set(_vm.form, "td_cargo", $$v)},expression:"form.td_cargo"}}),_vm._v(" "),(_vm.form.td_cargo === "Diretor (C-Level)")?_c('v-multiselect',{attrs:{"options":_vm.roleFunction,"show-labels":false,"placeholder":"Qual opção melhor se encaixa na sua função?","id":"clevel_funcao"},on:{"select":_vm.multiselectChange},model:{value:(_vm.form.clevel_funcao),callback:function ($$v) {_vm.$set(_vm.form, "clevel_funcao", $$v)},expression:"form.clevel_funcao"}}):_vm._e(),_vm._v(" "),_c('v-multiselect',{class:{ error: _vm.errorValidationForm.departamento },attrs:{"options":_vm.departament,"show-labels":false,"placeholder":"Departamento","id":"departamento"},on:{"select":_vm.multiselectChange},model:{value:(_vm.form.departamento),callback:function ($$v) {_vm.$set(_vm.form, "departamento", $$v)},expression:"form.departamento"}}),_vm._v(" "),_c('v-multiselect',{class:{ error: _vm.errorValidationForm.papel_td },attrs:{"options":_vm.transformationDigital,"show-labels":false,"placeholder":"Qual papel você exerce na transformação digital da sua empresa?","id":"papel_td"},on:{"select":_vm.multiselectChange},model:{value:(_vm.form.papel_td),callback:function ($$v) {_vm.$set(_vm.form, "papel_td", $$v)},expression:"form.papel_td"}})],1):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"nav-arrow nav-right",class:{ 'v-hidden': _vm.stepFormCurrent == 2 },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.checkForm1($event)}}},[_c('icon',{attrs:{"name":"arrow-right","half":""}})],1),_vm._v(" "),_c('div',{staticClass:"nav-lines"},[_c('a',{staticClass:"line",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.setForm(1)}}},[_c('div',{staticClass:"block",class:{ active: _vm.stepFormCurrent == 1 }})]),_vm._v(" "),_c('a',{staticClass:"line",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.checkForm1($event)}}},[_c('div',{staticClass:"block",class:{ active: _vm.stepFormCurrent == 2 }})])])],1),_vm._v(" "),_c('div',{staticClass:"box-full-footer"},[_c('v-button',{staticClass:"btn-prev",attrs:{"super-dark":"","arrow-left":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.prevStep($event)}}},[_vm._v("\n          Voltar\n        ")]),_vm._v(" "),_c('icon',{staticClass:"td-logo",attrs:{"name":"td-logo","color":"#393f49"}}),_vm._v(" "),(_vm.hasError)?_c('v-button',{staticClass:"btn-next",attrs:{"super-dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.checkAllForm($event)}}},[_vm._v("\n          Preencha o formulário\n        ")]):_c('v-button',{staticClass:"btn-next",attrs:{"super-dark":"","arrow":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.checkForm2($event)}}},[_vm._v("\n          Avançar\n        ")])],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v/eD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__("DiNV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daf68a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__("xY8p");
function injectStyle (ssrContext) {
  __webpack_require__("IWEL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1daf68a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daf68a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vaXp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/form.3f3086d.mp4";

/***/ }),

/***/ "wCtQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vButton_vue__ = __webpack_require__("jMCT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2358f4e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vButton_vue__ = __webpack_require__("yd4y");
function injectStyle (ssrContext) {
  __webpack_require__("GlIp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2358f4e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2358f4e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wWYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"Introdução","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/","next":"/pessoas"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BarProgress__ = __webpack_require__("W7jM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RequestError__ = __webpack_require__("5ypP");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { BarProgress: __WEBPACK_IMPORTED_MODULE_0__components_BarProgress__["a" /* default */], RequestError: __WEBPACK_IMPORTED_MODULE_1__components_RequestError__["a" /* default */] }
});

/* eslint-disable no-console */
var style = ['background: linear-gradient(45deg, #6e7a78 0%, #3b434d 100%);', 'color: white', 'padding: 24px 26px', 'font-size: 12px', 'line-height: 68px'].join(';');
console.log('%c TD Score | https://score.transformacaodigital.com', style);

/***/ }),

/***/ "xY8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question-description"},[_c('div',{staticClass:"question-number"},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('div',{staticClass:"question-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"question-answer",class:_vm.answerClass},[_vm._v("\n      "+_vm._s(_vm.answer)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"question-form"},[_c('v-slider',{on:{"input":_vm.changeInput},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xa4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__("uXHU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ead18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__("0rPL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ead18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xrWu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAApCAYAAAALSGYwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAcNJREFUeNrsm4FNwzAQRWPUATICG+ARwgQtG5QNOkKZIGICukHKBEk3yAZxN8gGcAcGVdCCbYR0Z/8vWZVcJ3L87uI792peSFWmMqRz/fTIDX30Qqc9UHumtqfpu5QbXFWQNLHBtdQmMr7eGyCgZgaYwbbUakDNSxsP1wJqXrKhYAFVl2oP9hpQ8wPb/bTHAqruV3ENqIWABVT9YLuvnSYludUiY8xwrt9btxU0VZ7Pkto68fodPes9bFygOKr1p0gpWmEFZcN9SoA6xZw6QXrAbrBy+YGdsGo6wHaRYC1SGvniqHaMGL/6TwsLjeK24PbrWjYRntrDU/Xk2y405wVUPRoCx2FPVaRj6EBA1aMbQM1PTeC4EVB1RL/r6v3QP0QOUOUDZZhtxCUHQJUPtI/w0rcoGVDlA4353XeknBZ7akZAWY+IfvMC6shLd4AqD2iTCJT1Wc6yKNgbpNQofcxl+Yc5PZzWYy0KdQpbyf0rY6y46Gx72oHXr36g36oIAVWvhktloYCqU1wJcXfpS0DVCfSWvHQG1EKAAqqyPTQEKKDq0Ozz0CCgJeepWmDuPVAXcyGgyoI4+nbwKcuccqNXAQYABNfvqgAXNAsAAAAASUVORK5CYII="

/***/ }),

/***/ "yM+l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yUI4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yd4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.to)?_c('router-link',{staticClass:"button",class:{
      dark: _vm.dark,
      big: _vm.big,
      outline: _vm.outline,
      'super-dark': _vm.superDark
    },attrs:{"to":_vm.to}},[(_vm.arrowLeft)?_c('icon',{staticClass:"arrow arrow-line-left",attrs:{"name":"arrow-line-right"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),(_vm.arrow)?_c('icon',{staticClass:"arrow arrow-line-right",attrs:{"name":"arrow-line-right"}}):_vm._e()],1):_c('a',{staticClass:"button",class:{
      dark: _vm.dark,
      big: _vm.big,
      outline: _vm.outline,
      'super-dark': _vm.superDark
    },attrs:{"href":_vm.href}},[(_vm.arrowLeft)?_c('icon',{staticClass:"arrow arrow-line-left",attrs:{"name":"arrow-line-right"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),(_vm.arrow)?_c('icon',{staticClass:"arrow arrow-line-right",attrs:{"name":"arrow-line-right"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ylXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__("ripP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vButton__ = __webpack_require__("wCtQ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'diagnosis',
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], vButton: __WEBPACK_IMPORTED_MODULE_3__vButton__["a" /* default */] },
  data: function data() {
    return {
      segmentCurrent: 0,
      stepCurrent: 1,
      stepFormCurrent: 1,
      errorValidationForm: {
        email: false,
        estado_sigla: false,
        business_model: false,
        numemployees: false,
        td_cargo: false,
        departamento: false,
        papel_td: false
      },
      hasError: true,
      // industry: ['Agência de Marketing/Publicidade', 'Tecnologia', 'Educação', 'Software e Cloud', 'Educação Superior', 'e-commerce', 'Varejo', 'Consultoria', 'Mídia e Comunicação', 'Turismo e Lazer', 'Saúde', 'RH e Recrutamento', 'Dinheiro e Finanças', 'Serviços Corporativos', 'Jurídico', 'Industria e Manufatura', 'Outros'],
      state: [{ sigla: 'AC', state: 'Acre' }, { sigla: 'AL', state: 'Alagoas' }, { sigla: 'AM', state: 'Amazonas' }, { sigla: 'AP', state: 'Amapá' }, { sigla: 'BA', state: 'Bahia' }, { sigla: 'CE', state: 'Ceará' }, { sigla: 'DF', state: 'Distrito Federal' }, { sigla: 'ES', state: 'Espírito Santo' }, { sigla: 'GO', state: 'Goiás' }, { sigla: 'MA', state: 'Maranhão' }, { sigla: 'MT', state: 'Mato Grosso' }, { sigla: 'MS', state: 'Mato Grosso do Sul' }, { sigla: 'MG', state: 'Minas Gerais' }, { sigla: 'PA', state: 'Pará' }, { sigla: 'PB', state: 'Paraíba' }, { sigla: 'PR', state: 'Paraná' }, { sigla: 'PE', state: 'Pernambuco' }, { sigla: 'PI', state: 'Piauí' }, { sigla: 'RJ', state: 'Rio de Janeiro' }, { sigla: 'RN', state: 'Rio Grande do Norte' }, { sigla: 'RS', state: 'Rio Grande do Sul' }, { sigla: 'RO', state: 'Rondônia' }, { sigla: 'RR', state: 'Roraima' }, { sigla: 'SC', state: 'Santa Catarina' }, { sigla: 'SE', state: 'Sergipe' }, { sigla: 'SP', state: 'São Paulo' }, { sigla: 'TO', state: 'Tocantins' }],
      model: ['B2B', 'B2C'],
      employees: ['Individual', '2-5', '5-25', '25-50', '50-100', '100-200', '200-500', '500-1000', '1000+'],
      role: ['Diretor (C-Level)', 'Gerente / Coordenador', 'Supervisor', 'Analista', 'Assistente', 'Estagiário'],
      roleFunction: ['CEO (Chief Executive Officer)', 'COO (Chief Operating Officer)', 'CFO (Chief Financial Officer)', 'CDO (Chief Digital Officer)', 'CTO (Chief Technology Officer)', 'CIO (Chief Information Officer)', 'CMO (Chief Marketing Officer)', 'CHRO (Chief Human Resources Officer)', 'Outros'],
      departament: ['Comercial', 'Financeiro', 'Gestão', 'Marketing', 'Pós-venda', 'Produto', 'Recursos Humanos', 'Tecnologia'],
      transformationDigital: ['Sou o responsável formal pela transformação em minha empresa', 'Não há responsável, mas estou iniciando o movimento', 'Apenas sou interessado pelo assunto'],
      form: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$store.state.diagnosis)
    };
  },
  mounted: function mounted() {
    this.autoSelectSegment();
    this.$store.commit('SET_BAR_PROGRESS', 6);
  },

  methods: {
    /* eslint-disable no-useless-escape */
    checkAllForm: function checkAllForm() {
      this.stepFormCurrent === 1 ? this.checkForm1() : this.checkForm2();
    },
    checkForm1: function checkForm1() {
      var _this = this;

      var fields = ['email', 'estado_sigla', 'business_model'];
      this.hasError = false;
      fields.forEach(function (field) {
        if (!_this.form[field]) {
          _this.errorValidationForm[field] = true;
          _this.hasError = true;
        }
      });
      if (this.hasError) {
        this.stepFormCurrent = 1;
      } else {
        this.$refs.submitStep1.click();
        this.hasError = true;
      }
    },
    checkForm2: function checkForm2() {
      var _this2 = this;

      var fields = ['numemployees', 'td_cargo', 'departamento', 'papel_td'];
      this.hasError = false;
      fields.forEach(function (field) {
        if (!_this2.form[field]) {
          _this2.errorValidationForm[field] = true;
          _this2.hasError = true;
        }
      });
      this.hasError ? this.stepFormCurrent = 2 : this.$router.push('/conclusao');
    },
    autoSelectSegment: function autoSelectSegment() {
      var _this3 = this;

      this.$el.querySelectorAll('.box-select .box-item').forEach(function (item) {
        if (item.text === _this3.form.industry) _this3.segmentCurrent = item.dataset.id;
      });
    },
    setForm: function setForm(step) {
      this.stepFormCurrent = step;
    },
    selectBox: function selectBox(e) {
      this.segmentCurrent = e.target.dataset.id;
      this.$store.commit('UPDATE_FIELD', {
        form: 'diagnosis',
        key: 'industry',
        value: e.target.text
      });
    },
    multiselectChange: function multiselectChange(newValue, id) {
      this.errorValidationForm[id] = false;
      this.$store.commit('UPDATE_FIELD', {
        form: 'diagnosis',
        key: id,
        value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newValue).includes('sigla') ? newValue.sigla : newValue
      });
    },
    inputChange: function inputChange(e) {
      var nameField = e.target.getAttribute('name');
      var newValue = e.target.value;
      this.$store.commit('UPDATE_FIELD', {
        form: 'diagnosis',
        key: nameField,
        value: newValue
      });
    },
    changeCargo: function changeCargo(value, id) {
      this.multiselectChange(value, id);
      if (value !== 'Diretor (C-Level)') {
        this.$store.commit('UPDATE_FIELD', {
          form: 'diagnosis',
          key: 'clevel_funcao',
          value: ''
        });
        this.form.clevel_funcao = '';
      }
    },
    nextForm: function nextForm() {
      this.stepFormCurrent = 2;
    },
    prevForm: function prevForm() {
      this.stepFormCurrent = 1;
    },
    nextStep: function nextStep() {
      this.stepCurrent += 1;
    },
    prevStep: function prevStep() {
      this.stepCurrent -= 1;
    }
  }
});

/***/ }),

/***/ "zadC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b55d46f1fbcd6ff8da47.js